import { guid } from "@progress/kendo-react-common";
import AlexAlbon from "../../../../assets/images/Driver/Alex-Albon.jpg";
import CarlosSainz from "../../../../assets/images/Driver/Carlos-Sainz.jpg"
import CharlesLeclerc from "../../../../assets/images/Driver/Charles-Leclerc.jpg"
import DanielRicciardo from "../../../../assets/images/Driver/Daniel-Ricciardo.jpg"
import EstebanOcon from "../../../../assets/images/Driver/Esteban-Ocon.jpg"
import FernandoAlonso from "../../../../assets/images/Driver/Fernando-Alonso.jpg"
import GeorgeRussell from "../../../../assets/images/Driver/George-Russell.jpg"
import KevinMagnussen from "../../../../assets/images/Driver/Kevin-Magnussen.jpg"
import LanceStroll from "../../../../assets/images/Driver/Lance-Stroll.jpg"
import LandoNorris from "../../../../assets/images/Driver/Lando-Norris.jpg"
import LewisHamilton from "../../../../assets/images/Driver/Lewis-Hamilton.jpg"
import LoganSargeant from "../../../../assets/images/Driver/Logan-Sargeant.jpg"
import MaxVerstappen from "../../../../assets/images/Driver/Max-Verstappen.jpg"
import NicoHulkenberg from "../../../../assets/images/Driver/Nico-Hulkenberg.jpg"
import PierreGasly from "../../../../assets/images/Driver/Pierre-Gasly.jpg"
import SergioPerez from "../../../../assets/images/Driver/Sergio-Perez.jpg"
import ValtteriBottas from "../../../../assets/images/Driver/Valtteri-Bottas.jpg"
export const tasks = [
    {
      text: 'New Brochures',
    },
    // {
    //   text: 'Brochure Design Review',
    // },
    // {
    //   text: 'Upgrade Personal Computers',
    // },
    // {
    //   text: 'Install New Router in Dev Room',
    // },
    // {
    //   text: 'Upgrade Server Hardware',
    // },
    // {
    //   text: 'Install New Database',
    // },
    // {
    //   text: 'Website Re-Design Plan',
    // },
    // {
    //   text: 'Create Icons for Website',
    // },
    // {
    //   text: 'Submit New Website Design',
    // },
    // {
    //   text: 'Launch New Website',
    // },
  ];  
  export const appointments = [
    {
      text: 'Book Flights to San Fran for Sales Trip',
      staBRUate: new Date('2021-04-26T19:00:00.000Z'),
      endDate: new Date('2021-04-26T20:00:00.000Z'),
      allDay: true,
    },
    {
      text: 'Approve Personal Computer Upgrade Plan',
      staBRUate: new Date('2021-04-27T17:00:00.000Z'),
      endDate: new Date('2021-04-27T18:00:00.000Z'),
    },
    {
      text: 'Final Budget Review',
      staBRUate: new Date('2021-04-27T19:00:00.000Z'),
      endDate: new Date('2021-04-27T20:35:00.000Z'),
    },
    {
      text: 'Approve New Online Marketing Strategy',
      staBRUate: new Date('2021-04-28T19:00:00.000Z'),
      endDate: new Date('2021-04-28T21:00:00.000Z'),
    },
    {
      text: 'Customer Workshop',
      staBRUate: new Date('2021-04-29T18:00:00.000Z'),
      endDate: new Date('2021-04-29T19:00:00.000Z'),
      allDay: true,
    },
    {
      text: 'Prepare 2021 Marketing Plan',
      staBRUate: new Date('2021-04-29T18:00:00.000Z'),
      endDate: new Date('2021-04-29T20:30:00.000Z'),
    },
  ];
  export const data = [
    {
      text: 'Google AdWords Strategy',
      ownerId: [2],
      staBRUate: new Date('2021-02-01T16:00:00.000Z'),
      endDate: new Date('2021-02-01T17:30:00.000Z'),
      priority: 1,
    },
    {
      text: 'New Brochures',
      ownerId: [1],
      staBRUate: new Date('2021-02-01T18:30:00.000Z'),
      endDate: new Date('2021-02-01T21:15:00.000Z'),
      priority: 2,
    },
    {
      text: 'Brochure Design Review',
      ownerId: [4],
      staBRUate: new Date('2021-02-01T20:15:00.000Z'),
      endDate: new Date('2021-02-01T23:15:00.000Z'),
      priority: 1,
    },
    {
      text: 'Website Re-Design Plan',
      ownerId: [3],
      staBRUate: new Date('2021-02-01T23:45:00.000Z'),
      endDate: new Date('2021-02-02T18:15:00.000Z'),
      priority: 2,
    },
    {
      text: 'Rollout of New Website and Marketing Brochures',
      ownerId: [1],
      staBRUate: new Date('2021-02-02T15:15:00.000Z'),
      endDate: new Date('2021-02-02T17:45:00.000Z'),
      priority: 2,
    },
    {
      text: 'Update Sales Strategy Documents',
      ownerId: [2],
      staBRUate: new Date('2021-02-02T19:00:00.000Z'),
      endDate: new Date('2021-02-02T20:45:00.000Z'),
      priority: 1,
    },
    {
      text: 'Non-Compete Agreements',
      ownerId: [4],
      staBRUate: new Date('2021-02-03T16:15:00.000Z'),
      endDate: new Date('2021-02-03T17:00:00.000Z'),
      priority: 1,
    },
    {
      text: 'Approve Hiring of John Jeffers',
      ownerId: [2],
      staBRUate: new Date('2021-02-03T17:00:00.000Z'),
      endDate: new Date('2021-02-03T18:15:00.000Z'),
      priority: 2,
    },
    {
      text: 'Update NDA Agreement',
      ownerId: [1],
      staBRUate: new Date('2021-02-03T18:45:00.000Z'),
      endDate: new Date('2021-02-03T20:45:00.000Z'),
      priority: 2,
    },
    {
      text: 'Update Employee Files with New NDA',
      ownerId: [2],
      staBRUate: new Date('2021-02-03T21:00:00.000Z'),
      endDate: new Date('2021-02-03T23:45:00.000Z'),
      priority: 1,
    },
    {
      text: 'Submit Questions Regarding New NDA',
      ownerId: [1],
      staBRUate: new Date('2021-02-05T01:00:00.000Z'),
      endDate: new Date('2021-02-04T16:30:00.000Z'),
      priority: 1,
    },
    {
      text: 'Submit Signed NDA',
      ownerId: [2],
      staBRUate: new Date('2021-02-04T19:45:00.000Z'),
      endDate: new Date('2021-02-04T21:00:00.000Z'),
      priority: 1,
    },
    {
      text: 'Review Revenue Projections',
      ownerId: [3],
      staBRUate: new Date('2021-02-05T00:15:00.000Z'),
      endDate: new Date('2021-02-04T15:00:00.000Z'),
      priority: 2,
    },
    {
      text: 'Comment on Revenue Projections',
      ownerId: [2],
      staBRUate: new Date('2021-02-05T16:15:00.000Z'),
      endDate: new Date('2021-02-05T18:15:00.000Z'),
      priority: 1,
    },
    {
      text: 'Provide New Health Insurance Docs',
      ownerId: [3],
      staBRUate: new Date('2021-02-05T19:45:00.000Z'),
      endDate: new Date('2021-02-05T21:15:00.000Z'),
      priority: 2,
    },
    {
      text: 'Review Changes to Health Insurance Coverage',
      ownerId: [2],
      staBRUate: new Date('2021-02-05T21:15:00.000Z'),
      endDate: new Date('2021-02-05T22:30:00.000Z'),
      priority: 1,
    },
    {
      text: 'Review Training Course for any Omissions',
      ownerId: [2],
      staBRUate: new Date('2021-02-08T21:00:00.000Z'),
      endDate: new Date('2021-02-09T19:00:00.000Z'),
      priority: 2,
    },
    {
      text: 'Recall Rebate Form',
      ownerId: [1],
      staBRUate: new Date('2021-02-08T19:45:00.000Z'),
      endDate: new Date('2021-02-08T20:15:00.000Z'),
      priority: 1,
    },
    {
      text: 'Create Report on Customer Feedback',
      ownerId: [4],
      startDate: new Date('2021-02-09T22:15:00.000Z'),
      endDate: new Date('2021-02-10T00:30:00.000Z'),
      priority: 2,
    },
    {
      text: 'Review Customer Feedback Report',
      ownerId: [2],
      startDate: new Date('2021-02-09T23:15:00.000Z'),
      endDate: new Date('2021-02-10T01:30:00.000Z'),
      priority: 1,
    },
    {
      text: 'Customer Feedback Report Analysis',
      ownerId: [3],
      startDate: new Date('2021-02-10T16:30:00.000Z'),
      endDate: new Date('2021-02-10T17:30:00.000Z'),
      priority: 1,
    },
    {
      text: 'Prepare Shipping Cost Analysis Report',
      ownerId: [4],
      startDate: new Date('2021-02-10T19:30:00.000Z'),
      endDate: new Date('2021-02-10T20:30:00.000Z'),
      priority: 1,
    },
    {
      text: 'Provide Feedback on Shippers',
      ownerId: [2],
      startDate: new Date('2021-02-10T21:15:00.000Z'),
      endDate: new Date('2021-02-10T23:00:00.000Z'),
      priority: 2,
    },
    {
      text: 'Select Preferred Shipper',
      ownerId: [1],
      startDate: new Date('2021-02-11T00:30:00.000Z'),
      endDate: new Date('2021-02-11T03:00:00.000Z'),
      priority: 1,
    },
    {
      text: 'Complete Shipper Selection Form',
      ownerId: [2],
      startDate: new Date('2021-02-11T15:30:00.000Z'),
      endDate: new Date('2021-02-11T17:00:00.000Z'),
      priority: 2,
    },
    {
      text: 'Upgrade Server Hardware',
      ownerId: [4],
      startDate: new Date('2021-02-11T19:00:00.000Z'),
      endDate: new Date('2021-02-11T21:15:00.000Z'),
      priority: 1,
    },
    {
      text: 'Upgrade Personal Computers',
      ownerId: [3],
      startDate: new Date('2021-02-11T21:45:00.000Z'),
      endDate: new Date('2021-02-11T23:30:00.000Z'),
      priority: 1,
    },
    {
      text: 'Upgrade Apps to Windows RT or stay with WinForms',
      ownerId: [1],
      startDate: new Date('2021-02-12T17:30:00.000Z'),
      endDate: new Date('2021-02-12T20:00:00.000Z'),
      priority: 1,
    },
    {
      text: 'Estimate Time Required to Touch-Enable Apps',
      ownerId: [1],
      startDate: new Date('2021-02-12T21:45:00.000Z'),
      endDate: new Date('2021-02-12T23:30:00.000Z'),
      priority: 1,
    },
    {
      text: 'Report on Tranistion to Touch-Based Apps',
      ownerId: [2],
      startDate: new Date('2021-02-13T01:30:00.000Z'),
      endDate: new Date('2021-02-13T02:00:00.000Z'),
      priority: 1,
    },
    {
      text: 'Submit New Website Design',
      ownerId: [2],
      startDate: new Date('2021-02-15T15:00:00.000Z'),
      endDate: new Date('2021-02-15T17:00:00.000Z'),
      priority: 2,
    },
    {
      text: 'Create Icons for Website',
      ownerId: [4],
      startDate: new Date('2021-02-15T18:30:00.000Z'),
      endDate: new Date('2021-02-15T20:15:00.000Z'),
      priority: 1,
    },
    {
      text: 'Create New Product Pages',
      ownerId: [1],
      startDate: new Date('2021-02-16T16:45:00.000Z'),
      endDate: new Date('2021-02-16T18:45:00.000Z'),
      priority: 2,
    },
    {
      text: 'Approve Website Launch',
      ownerId: [3],
      startDate: new Date('2021-02-16T19:00:00.000Z'),
      endDate: new Date('2021-02-16T22:15:00.000Z'),
      priority: 1,
    },
    {
      text: 'Update Customer Shipping Profiles',
      ownerId: [3],
      startDate: new Date('2021-02-17T16:30:00.000Z'),
      endDate: new Date('2021-02-17T18:00:00.000Z'),
      priority: 1,
    },
    {
      text: 'Create New Shipping Return Labels',
      ownerId: [4],
      startDate: new Date('2021-02-17T19:45:00.000Z'),
      endDate: new Date('2021-02-17T21:00:00.000Z'),
      priority: 1,
    },
    {
      text: 'Get Design for Shipping Return Labels',
      ownerId: [3],
      startDate: new Date('2021-02-17T22:00:00.000Z'),
      endDate: new Date('2021-02-17T23:30:00.000Z'),
      priority: 1,
    },
    {
      text: 'PSD needed for Shipping Return Labels',
      ownerId: [4],
      startDate: new Date('2021-02-18T15:30:00.000Z'),
      endDate: new Date('2021-02-18T16:15:00.000Z'),
      priority: 2,
    },
    {
      text: 'Contact ISP and Discuss Payment Options',
      ownerId: [1],
      startDate: new Date('2021-02-18T18:30:00.000Z'),
      endDate: new Date('2021-02-18T23:00:00.000Z'),
      priority: 2,
    },
    {
      text: 'Prepare Year-End Support Summary Report',
      ownerId: [2],
      startDate: new Date('2021-02-19T00:00:00.000Z'),
      endDate: new Date('2021-02-19T03:00:00.000Z'),
      priority: 1,
    },
    {
      text: 'Review New Training Material',
      ownerId: [3],
      startDate: new Date('2021-02-19T15:00:00.000Z'),
      endDate: new Date('2021-02-19T16:15:00.000Z'),
      priority: 2,
    },
    {
      text: 'Distribute Training Material to Support Staff',
      ownerId: [2],
      startDate: new Date('2021-02-19T19:45:00.000Z'),
      endDate: new Date('2021-02-19T21:00:00.000Z'),
      priority: 1,
    },
    {
      text: 'Training Material Distribution Schedule',
      ownerId: [2],
      startDate: new Date('2021-02-19T21:15:00.000Z'),
      endDate: new Date('2021-02-19T23:15:00.000Z'),
      priority: 1,
    },
    {
      text: 'Approval on Converting to New HDMI Specification',
      ownerId: [4],
      startDate: new Date('2021-02-22T16:30:00.000Z'),
      endDate: new Date('2021-02-22T17:15:00.000Z'),
      priority: 2,
    },
    {
      text: 'Create New Spike for Automation Server',
      ownerId: [3],
      startDate: new Date('2021-02-22T17:00:00.000Z'),
      endDate: new Date('2021-02-22T19:30:00.000Z'),
      priority: 2,
    },
    {
      text: 'Code Review - New Automation Server',
      ownerId: [1],
      startDate: new Date('2021-02-22T20:00:00.000Z'),
      endDate: new Date('2021-02-22T22:00:00.000Z'),
      priority: 1,
    },
    {
      text: 'Confirm Availability for Sales Meeting',
      ownerId: [1],
      startDate: new Date('2021-02-23T17:15:00.000Z'),
      endDate: new Date('2021-02-23T22:15:00.000Z'),
      priority: 2,
    },
    {
      text: 'Reschedule Sales Team Meeting',
      ownerId: [2],
      startDate: new Date('2021-02-23T23:15:00.000Z'),
      endDate: new Date('2021-02-24T01:00:00.000Z'),
      priority: 2,
    },
    {
      text: 'Send 2 Remotes for Giveaways',
      ownerId: [3],
      startDate: new Date('2021-02-24T16:30:00.000Z'),
      endDate: new Date('2021-02-24T18:45:00.000Z'),
      priority: 1,
    },
    {
      text: 'Discuss Product Giveaways with Management',
      ownerId: [1],
      startDate: new Date('2021-02-24T19:15:00.000Z'),
      endDate: new Date('2021-02-24T23:45:00.000Z'),
      priority: 2,
    },
    {
      text: 'Replace Desktops on the 3rd Floor',
      ownerId: [2],
      startDate: new Date('2021-02-25T16:30:00.000Z'),
      endDate: new Date('2021-02-25T17:45:00.000Z'),
      priority: 1,
    },
    {
      text: 'Update Database with New Leads',
      ownerId: [3],
      startDate: new Date('2021-02-25T19:00:00.000Z'),
      endDate: new Date('2021-02-25T21:15:00.000Z'),
      priority: 2,
    },
    {
      text: 'Mail New Leads for Follow Up',
      ownerId: [1],
      startDate: new Date('2021-02-25T21:45:00.000Z'),
      endDate: new Date('2021-02-25T22:30:00.000Z'),
      priority: 2,
    },
    {
      text: 'Send Territory Sales Breakdown',
      ownerId: [2],
      startDate: new Date('2021-02-26T01:00:00.000Z'),
      endDate: new Date('2021-02-26T03:00:00.000Z'),
      priority: 1,
    },
    {
      text: 'Territory Sales Breakdown Report',
      ownerId: [1],
      startDate: new Date('2021-02-26T15:45:00.000Z'),
      endDate: new Date('2021-02-26T16:45:00.000Z'),
      priority: 1,
    },
    {
      text: 'Report on the State of Engineering Dept',
      ownerId: [3],
      startDate: new Date('2021-02-26T21:45:00.000Z'),
      endDate: new Date('2021-02-26T22:30:00.000Z'),
      priority: 2,
    },
    {
      text: 'Staff Productivity Report',
      ownerId: [4],
      startDate: new Date('2021-02-26T23:15:00.000Z'),
      endDate: new Date('2021-02-27T02:30:00.000Z'),
      priority: 2,
    },
  ];
  const vhColor = "#64c6bb"
  const scColor = "#64c6bb"
  const trColor = "#64c6bb"
export const LOAD = "LOAD"
export const LOADDEPOT = "LOADDEPOT"
export const UNLOAD = "UNLOAD"
export const UNLOADDEPOT = "UNLOADDEPOT"
export const PICKUP = "PICKUP"
export const DEPOSIT = "DEPOSIT"
export const COUPLE = "COUPLE"
export const UNCOUPLE = "UNCOUPLE"
export const FERRYON = "FERRY ON"
export const FERRYOF = "FERRY OFF"
export const CLEANING = "CLEANING"
export const BREAK = "BREAK"
export const DRIVE = "DRIVE"
export const HOOKON = "HOOK ON"
export const HOOKOF = "HOOK OFF"
  export const resourcesData = [
    {
      "text": "VH-1-DB",
      "id": "VH-1",
      "color": vhColor,
      "groupId": 1
    },
    {
      "text": "VH-2-DB",
      "id": "VH-2",
      "color": vhColor,
      "groupId": 1
    },
    {
      "text": "VH-3-DB",
      "id": "VH-3",
      "color": vhColor,
      "groupId": 1
    },
    {
      "text": "VH-4-DB",
      "id": "VH-4",
      "color": vhColor,
      "groupId": 1
    },
    {
      "text": "VH-5-DB",
      "id": "VH-5",
      "color": vhColor,
      "groupId": 1
    },
    {
      "text": "VH-6-DB",
      "id": "VH-6",
      "color": vhColor,
      "groupId": 1
    },
    {
      "text": "VH-7-DB",
      "id": "VH-7",
      "color": vhColor,
      "groupId": 1
    },
    {
      "text": "VH-8-DB",
      "id": "VH-8",
      "color": vhColor,
      "groupId": 1
    },
    {
      "text": "VH-9-DB",
      "id": "VH-9",
      "color": vhColor,
      "groupId": 1
    },
    {
      "text": "VH-10-DB",
      "id": "VH-10",
      "color": vhColor,
      "groupId": 1
    },
    {
      "text": "VH-11-DB",
      "id": "VH-11",
      "color": vhColor,
      "groupId": 1
    },
    {
      "text": "VH-12-DB",
      "id": "VH-12",
      "color": vhColor,
      "groupId": 1
    },
    {
      "text": "VH-13-DB",
      "id": "VH-13",
      "color": vhColor,
      "groupId": 1
    },
    {
      "text": "VH-14-DB",
      "id": "VH-14",
      "color": vhColor,
      "groupId": 1
    },
    {
      "text": "VH-15-DB",
      "id": "VH-15",
      "color": vhColor,
      "groupId": 1
    },
    {
      "text": "SC-1-DB",
      "id": "SC-1",
      "color": scColor,
      "groupId": 2
    },
    {
      "text": "SC-2-DB",
      "id": "SC-2",
      "color": scColor,
      "groupId": 2
    },
    {
      "text": "SC-3-DB",
      "id": "SC-3",
      "color": scColor,
      "groupId": 2
    },
    {
      "text": "SC-4-DB",
      "id": "SC-4",
      "color": scColor,
      "groupId": 2
    },
    {
      "text": "SC-5-DB",
      "id": "SC-5",
      "color": scColor,
      "groupId": 2
    },
    {
      "text": "SC-6-DB",
      "id": "SC-6",
      "color": scColor,
      "groupId": 2
    },
    {
      "text": "SC-7-DB",
      "id": "SC-7",
      "color": scColor,
      "groupId": 2
    },
    {
      "text": "SC-8-DB",
      "id": "SC-8",
      "color": scColor,
      "groupId": 2
    },
    {
      "text": "SC-9-DB",
      "id": "SC-9",
      "color": scColor,
      "groupId": 2
    },
    {
      "text": "SC-10-DB",
      "id": "SC-10",
      "color": scColor,
      "groupId": 2
    },
    {
      "text": "SC-11-DB",
      "id": "SC-11",
      "color": scColor,
      "groupId": 2
    },
    {
      "text": "SC-12-DB",
      "id": "SC-12",
      "color": scColor,
      "groupId": 2
    },
    {
      "text": "SC-13-DB",
      "id": "SC-13",
      "color": scColor,
      "groupId": 2
    },
    {
      text: 'TR-123-XK',
      id: 7,
      color: trColor,
      groupId:3
    },
    {
      text: 'TR-78-QK',
      id: 8,
      color: trColor,
      groupId:3
    },
    {
      text: 'TR-789-KD',
      id: 9,
      color: trColor,
      groupId:3
    },{
      "text": "TR-1-DB",
      "id": "TR-1",
      "color": trColor,
      "groupId": 3
    },
    {
      "text": "TR-2-DB",
      "id": "TR-2",
      "color": trColor,
      "groupId": 3
    },
    {
      "text": "TR-3-DB",
      "id": "TR-3",
      "color": trColor,
      "groupId": 3
    },
    {
      "text": "TR-4-DB",
      "id": "TR-4",
      "color": trColor,
      "groupId": 3
    },
    {
      "text": "TR-5-DB",
      "id": "TR-5",
      "color": trColor,
      "groupId": 3
    },
    {
      "text": "TR-6-DB",
      "id": "TR-6",
      "color": trColor,
      "groupId": 3
    },
    {
      "text": "TR-7-DB",
      "id": "TR-7",
      "color": trColor,
      "groupId": 3
    },
    {
      "text": "TR-8-DB",
      "id": "TR-8",
      "color": trColor,
      "groupId": 3
    },
    {
      "text": "TR-9-DB",
      "id": "TR-9",
      "color": trColor,
      "groupId": 3
    },
    {
      "text": "TR-10-DB",
      "id": "TR-10",
      "color": trColor,
      "groupId": 3
    },
    {
      "text": "TR-11-DB",
      "id": "TR-11",
      "color": trColor,
      "groupId": 3
    },
    {
      "text": "TR-12-DB",
      "id": "TR-12",
      "color": trColor,
      "groupId": 3
    },
    {
      "text": "TR-13-DB",
      "id": "TR-13",
      "color": trColor,
      "groupId": 3
    },
    {
      "text": "TR-14-DB",
      "id": "TR-14",
      "color": trColor,
      "groupId": 3
    },
    {
      "text": "TR-15-DB",
      "id": "TR-15",
      "color": trColor,
      "groupId": 3
    }
  ];
  export const priorityData = [
    {
      text: 'Low Priority',
      id: 1,
      color: '#cde3f1',
    },
    {
      text: 'High Priority',
      id: 2,
      color: '#ff9747',
    },
  ];
  const now = new Date();
  var tommorow = new Date();
  tommorow.setDate(tommorow.getDate() + 1)
  export const eventsData = [
    {      
      "title": "Event 548",
      "text": "Event 548",
      "startDate":now.setHours(0,0,0,0),
      "endDate": now.setHours(10),
      "allDay": false,
      "vehicle": "VH-1"
    },    
    {      
      "title": "Event 163",
      "text": "Event 163",
      "startDate":now.setHours(4,0,0,0),
      "endDate": now.setHours(12,0,0,0),
      "allDay": false,
      "vehicle": "VH-3"
    },
    {      
      "title": "Event 906",
      "text": "Event 906",
      "startDate":now,
      "endDate": now.setHours(20,0,0,0),
      "allDay": false,
      "vehicle": "VH-4"
    },
    {      
      "title": "Event 940",
      "text": "Event 940",
      "startDate":now.setHours(3,0,0,0),
      "endDate": tommorow,
      "allDay": false,
      "vehicle": "VH-5"
    },
    {      
      "title": "Event 769",
      "text": "Event 769",
      "startDate":now,
      "endDate": tommorow,
      "allDay": false,
      "vehicle": "VH-6"
    },
    {      
      "title": "Event 468",
      "text": "Event 468",
      "startDate":now.setHours(0,0,0,0),
      "endDate": tommorow,
      "allDay": false,
      "vehicle": "VH-7"
    },
    {      
      "title": "Event 98",
      "text": "Event 98",
      "startDate":now,
      "endDate": tommorow,
      "allDay": false,
      "vehicle": "VH-8"
    },
    {      
      "title": "Event 475",
      "text": "Event 475",
      "startDate":now.setHours(7,0,0,0),
      "endDate": tommorow,
      "allDay": false,
      "vehicle": "VH-9"
    },
    {      
      "title": "Event 176",
      "text": "Event 176",
      "startDate":now,
      "endDate": tommorow,
      "allDay": false,
      "vehicle": "VH-10"
    },
    {      
      "title": "Event 475",
      "text": "Event 475",
      "startDate":now.setHours(1,0,0,0),
      "endDate": tommorow,
      "allDay": false,
      "vehicle": "VH-11"
    },
    {      
      "title": "Event 543",
      "text": "Event 543",
      "startDate":now,
      "endDate": tommorow,
      "allDay": false,
      "vehicle": "VH-12"
    },
    {      
      "title": "Event 505",
      "text": "Event 505",
      "startDate":now.setHours(3,0,0,0),
      "endDate": tommorow,
      "allDay": false,
      "vehicle": "VH-13"
    },
    {      
      "title": "Event 677",
      "text": "Event 677",
      "startDate":now,
      "endDate": tommorow,
      "allDay": false,
      "vehicle": "VH-14"
    },
    {      
      "title": "Event 547",
      "text": "Event 547",
      "startDate":now.setHours(4,0,0,0),
      "endDate": tommorow,
      "allDay": false,
      "vehicle": "VH-15"
    },
    {
      "title": "Event 618",
      "text": "Event 618",
      "startDate": now.setHours(10,0,0,0),
      "endDate": tommorow,
      "allDay": false,
      "vehicle": "SC-1"
    },
    {
      "title": "Event 331",
      "text": "Event 331",
      "startDate": now.setHours(11,0,0,0),
      "endDate": tommorow,
      "allDay": false,
      "vehicle": "SC-2"
    },
    {
      "title": "Event 654",
      "text": "Event 654",
      "startDate": now.setHours(14,0,0,0),
      "endDate": now.setHours(16,0,0,0),
      "allDay": false,
      "vehicle": "SC-3"
    },
    {
      "title": "Event 530",
      "text": "Event 530",
      "startDate": now,
      "endDate": tommorow,
      "allDay": false,
      "vehicle": "SC-4"
    },
    {
      "title": "Event 913",
      "text": "Event 913",
      "startDate": now.setHours(4,0,0,0),
      "endDate": tommorow,
      "allDay": false,
      "vehicle": "SC-5"
    },
    {
      "title": "Event 415",
      "text": "Event 415",
      "startDate": now.setHours(0,0,0,0),
      "endDate": tommorow,
      "allDay": false,
      "vehicle": "SC-6"
    },
    {
      "title": "Event 161",
      "text": "Event 161",
      "startDate": now.setHours(5,0,0,0),
      "endDate": tommorow,
      "allDay": false,
      "vehicle": "SC-7"
    },
    {
      "title": "Event 253",
      "text": "Event 253",
      "startDate": now.setHours(4,0,0,0),
      "endDate": tommorow,
      "allDay": false,
      "vehicle": "SC-8"
    },
    {
      "title": "Event 765",
      "text": "Event 765",
      "startDate": now,
      "endDate": tommorow,
      "allDay": false,
      "vehicle": "SC-9"
    },
    {
      "title": "Event 531",
      "text": "Event 531",
      "startDate": now.setHours(0,0,0,0),
      "endDate": tommorow,
      "allDay": false,
      "vehicle": "SC-10"
    },
    {
      "title": "Event 781",
      "text": "Event 781",
      "startDate": now,
      "endDate": tommorow,
      "allDay": false,
      "vehicle": "SC-11"
    },
    {
      "title": "Event 832",
      "text": "Event 832",
      "startDate": now.setHours(6,0,0,0),
      "endDate": tommorow,
      "allDay": false,
      "vehicle": "SC-12"
    },
    {
      "title": "Event 326",
      "text": "Event 326",
      "startDate": now,
      "endDate": tommorow,
      "allDay": false,
      "vehicle": "SC-13"
    },
    {
      "title": "Event 859",
      "text": "Event 859",
      "startDate": now.setHours(4,0,0,0),
      "endDate": tommorow,
      "allDay": false,
      "vehicle": "SC-14"
    },
    {
      "title": "Event 78",
      "text": "Event 78",
      "startDate": now.setHours(2,0,0,0),
      "endDate": tommorow,
      "allDay": false,
      "vehicle": "SC-15"
    },
    {
      "title": "Event 822",
      "text": "Event 822",
      "startDate": now.setHours(6,0,0,0),
      "endDate": now.setHours(10,0,0,0),
      "allDay": false,
      "vehicle": "TR-1"
    },
    {
      "title": "Event 997",
      "text": "Event 997",
      "startDate": now.setHours(5,0,0,0),
      "endDate": now.setHours(12,0,0,0),
      "allDay": false,
      "vehicle": "TR-2"
    },
    {
      "title": "Event 685",
      "text": "Event 685",
      "startDate": now,
      "endDate": tommorow,
      "allDay": false,
      "vehicle": "TR-3"
    },
    {
      "title": "Event 859",
      "text": "Event 859",
      "startDate": now.setHours(4,0,0,0),
      "endDate": tommorow,
      "allDay": false,
      "vehicle": "TR-4"
    },
    {
      "title": "Event 877",
      "text": "Event 877",
      "startDate": now.setHours(0,0,0,0),
      "endDate": tommorow,
      "allDay": false,
      "vehicle": "TR-5"
    },
    {
      "title": "Event 190",
      "text": "Event 190",
      "startDate": now.setHours(7,0,0,0),
      "endDate": now.setHours(23,0,0,0),
      "allDay": false,
      "vehicle": "TR-6"
    },
    {
      "title": "Event 925",
      "text": "Event 925",
      "startDate": now.setHours(9,0,0,0),
      "endDate": tommorow,
      "allDay": false,
      "vehicle": "TR-7"
    },
    {
      "title": "Event 262",
      "text": "Event 262",
      "startDate": now.setHours(10,0,0,0),
      "endDate": tommorow,
      "allDay": false,
      "vehicle": "TR-8"
    },
    {
      "title": "Event 605",
      "text": "Event 605",
      "startDate": now.setHours(4,0,0,0),
      "endDate": tommorow,
      "allDay": false,
      "vehicle": "TR-9"
    },
    {
      "title": "Event 296",
      "text": "Event 296",
      "startDate": now.setHours(12,0,0,0),
      "endDate": tommorow,
      "allDay": false,
      "vehicle": "TR-10"
    },
    {
      "title": "Event 291",
      "text": "Event 291",
      "startDate": now.setHours(5,0,0,0),
      "endDate": now.setHours(12,0,0,0),
      "allDay": false,
      "vehicle": "TR-11"
    },
    {
      "title": "Event 2",
      "text": "Event 2",
      "startDate": now.setHours(2,0,0,0),
      "endDate": tommorow,
      "allDay": false,
      "vehicle": "TR-12"
    },
    {
      "title": "Event 365",
      "text": "Event 365",
      "startDate": now.setHours(15,0,0,0),
      "endDate": tommorow,
      "allDay": false,
      "vehicle": "TR-13"
    },
    {
      "title": "Event 102",
      "text": "Event 102",
      "startDate": now.setHours(4,0,0,0),
      "endDate": tommorow,
      "allDay": false,
      "vehicle": "TR-14"
    },
    {
      "title": "Event 361",
      "text": "Event 361",
      "startDate": now,
      "endDate": tommorow,
      "allDay": false,
      "vehicle": "TR-15"
    }
  ]
  export const kendoEventsData = [
    {
      "Start": new Date(now.setHours(0,0,0,0)),
      "End": new Date(now.setHours(5,0,0,0)),
      "isAllDay": false,
      "resourceNo": "VH-357-DB",
      "Title": "Tst2",
      "TaskID": guid()
  },
    {
      "id": 2,
      "Start": new Date(now.setHours(3,0,0,0)),
      "End": new Date(now.setHours(10,0,0,0)),
      "isAllDay": false,
      "resourceNo": "VH-357-DB",
      "Title": "Event 2",
      "recurrenceRule": null,
      "TaskID": guid()
    },
    {
      "id": 3,
      "Start": new Date(now.setHours(1,0,0,0)),
      "End": new Date(now.setHours(5,0,0,0)),
      "isAllDay": false,
      "resourceNo": "VH-358-DB",
      "Title": "Event 3",
      "recurrenceRule": null,
      "TaskID": guid()
    },
    {
      "id": 4,
      "Start": new Date(now.setHours(10,0,0,0)),
      "End": new Date(now.setHours(12,0,0,0)),
      "isAllDay": false,
      "resourceNo": "VH-359-DB",
      "Title": "Event 4",
      "recurrenceRule": null,
      "TaskID": guid()
    },
    {
      "id": 5,
      "Start": new Date(now.setHours(6,0,0,0)),
      "End": new Date(now.setHours(12,0,0,0)),
      "isAllDay": false,
      "resourceNo": "VH-360-DB",
      "Title": "Event 5",
      "recurrenceRule": null,
      "TaskID": guid()
    },
    {
      "id": 6,
      "Start": new Date(now.setHours(15,0,0,0)),
      "End": new Date(now.setHours(18,0,0,0)),
      "isAllDay": false,
      "resourceNo": "VH-361-DB",
      "Title": "Event 6",
      "recurrenceRule": null,
      "TaskID": guid()
    },
    {
      "id": 7,
      "Start": new Date(now.setHours(15,0,0,0)),
      "End": new Date(now.setHours(23,0,0,0)),
      "isAllDay": false,
      "resourceNo": "VH-362-DB",
      "Title": "Event 7",
      "recurrenceRule": null,
      "TaskID": guid()
    },
    {
      "id": 8,
      "Start": new Date(now.setHours(0,0,0,0)),
      "End": new Date(now.setHours(12,0,0,0)),
      "isAllDay": false,
      "resourceNo": "VH-363-DB",
      "Title": "Event 8",
      "recurrenceRule": null,
      "TaskID": guid()
    },
    {
      "id": 9,
      "Start": new Date(now.setHours(3,30,0,0)),
      "End": new Date(now.setHours(5,0,0,0)),
      "isAllDay": false,
      "resourceNo": "VH-364-DB",
      "Title": "Event 9",
      "recurrenceRule": null,
      "TaskID": guid()
    },
    {
      "id": 10,
      "Start": new Date(now.setHours(4,0,0,0)),
      "End": tommorow,
      "isAllDay": false,
      "resourceNo": "VH-365-DB",
      "Title": "Event 10",
      "recurrenceRule": null,
      "TaskID": guid()
    },
    {
      "id": 11,
      "Start": new Date(now.setHours(12,0,0,0)),
      "End": tommorow,
      "isAllDay": false,
      "resourceNo": "VH-366-DB",
      "Title": "Event 1",
      "recurrenceRule": null,
      "TaskID": guid()
    },
    {
      "id": 12,
      "Start": new Date(now.setHours(5,0,0,0)),
      "End": new Date(now.setHours(10,0,0,0)),
      "isAllDay": false,
      "resourceNo": "VH-367-DB",
      "Title": "Event 2",
      "recurrenceRule": null,
      "TaskID": guid()
    },
    {
      "id": 13,
      "Start": new Date(now.setHours(0,0,0,0)),
      "End": new Date(now.setHours(6,0,0,0)),
      "isAllDay": false,
      "resourceNo": "VH-368-DB",
      "Title": "Event 3",
      "recurrenceRule": null,
      "TaskID": guid()
    },
    {
      "id": 14,
      "Start": new Date(now.setHours(9,0,0,0)),
      "End": new Date(now.setHours(15,0,0,0)),
      "isAllDay": false,
      "resourceNo": "VH-369-DB",
      "Title": "Event 4",
      "recurrenceRule": null,
      "TaskID": guid()
    },
    {
      "id": 15,
      "Start": now,
      "End": tommorow,
      "isAllDay": false,
      "resourceNo": "VH-370-DB",
      "Title": "Event 5",
      "recurrenceRule": null,
      "TaskID": guid()
    },
    {
      "id": 16,
      "Start": new Date(now.setHours(12,0,0,0)),
      "End": tommorow,
      "isAllDay": false,
      "resourceNo": "VH-371-DB",
      "Title": "Event 6",
      "recurrenceRule": null,
      "TaskID": guid()
    },
    {
      "id": 17,
      "Start": new Date(now.setHours(0,0,0,0)),
      "End": tommorow,
      "isAllDay": false,
      "resourceNo": "VH-372-DB",
      "Title": "Event 7",
      "recurrenceRule": null,
      "TaskID": guid()
    },
    {
      "id": 18,
      "Start": new Date(now.setHours(5,0,0,0)),
      "End": tommorow,
      "isAllDay": false,
      "resourceNo": "VH-373-DB",
      "Title": "Event 8",
      "recurrenceRule": null,
      "TaskID": guid()
    },
    {
      "id": 19,
      "Start": new Date(now.setHours(2,0,0,0)),
      "End": tommorow,
      "isAllDay": false,
      "resourceNo": "VH-374-DB",
      "Title": "Event 9",
      "recurrenceRule": null,
      "TaskID": guid()
    },
    {
      "id": 20,
      "Start": new Date(now.setHours(5,0,0,0)),
      "End": tommorow,
      "isAllDay": false,
      "resourceNo": "VH-375-DB",
      "Title": "Event 10",
      "recurrenceRule": null,
      "TaskID": guid()
    },
    {
      "id": 21,
      "Start": new Date(now.setHours(6,0,0,0)),
      "End": new Date(now.setHours(8,0,0,0)),
      "isAllDay": false,
      "resourceNo": "VH-376-DB",
      "Title": "Event 1",
      "recurrenceRule": null,
      "TaskID": guid()
    },
    {
      "id": 22,
      "Start": new Date(now.setHours(1,0,0,0)),
      "End": new Date(now.setHours(9,0,0,0)),
      "isAllDay": false,
      "resourceNo": "VH-377-DB",
      "Title": "Event 2",
      "recurrenceRule": null,
      "TaskID": guid()
    },
    {
      "id": 23,
      "Start": new Date(now.setHours(5,0,0,0)),
      "End": new Date(now.setHours(10,0,0,0)),
      "isAllDay": false,
      "resourceNo": "VH-378-DB",
      "Title": "Event 3",
      "recurrenceRule": null,
      "TaskID": guid()
    },
    {
      "id": 24,
      "Start": new Date(now.setHours(1,0,0,0)),
      "End": new Date(now.setHours(10,0,0,0)),
      "isAllDay": false,
      "resourceNo": "VH-379-DB",
      "Title": "Event 4",
      "recurrenceRule": null,
      "TaskID": guid()
    },
    {
      "id": 25,
      "Start": new Date(now.setHours(6,0,0,0)),
      "End": new Date(now.setHours(10,0,0,0)),
      "isAllDay": false,
      "resourceNo": "VH-380-DB",
      "Title": "Event 5",
      "recurrenceRule": null,
      "TaskID": guid()
    },
    {
      "id": 26,
      "Start": new Date(now.setHours(5,0,0,0)),
      "End": new Date(now.setHours(10,0,0,0)),
      "isAllDay": false,
      "resourceNo": "VH-381-DB",
      "Title": "Event 6",
      "recurrenceRule": null,
      "TaskID": guid()
    },
    {
      "id": 27,
      "Start": new Date(now.setHours(10,0,0,0)),
      "End": tommorow,
      "isAllDay": false,
      "resourceNo": "VH-382-DB",
      "Title": "Event 7",
      "recurrenceRule": null,
      "TaskID": guid()
    },
    {
      "id": 28,
      "Start": new Date(now.setHours(8,0,0,0)),
      "End": tommorow,
      "isAllDay": false,
      "resourceNo": "VH-383-DB",
      "Title": "Event 8",
      "recurrenceRule": null,
      "TaskID": guid()
    },
    {
      "id": 29,
      "Start": new Date(now.setHours(10,0,0,0)),
      "End": new Date(now.setHours(20,0,0,0)),
      "isAllDay": false,
      "resourceNo": "VH-384-DB",
      "Title": "Event 9",
      "recurrenceRule": null,
      "TaskID": guid()
    },
    {
      "id": 30,
      "Start": new Date(now.setHours(8,0,0,0)),
      "End": new Date(now.setHours(10,0,0,0)),
      "isAllDay": false,
      "resourceNo": "VH-385-DB",
      "Title": "Event 10",
      "recurrenceRule": null,
      "TaskID": guid()
    },
    {
      "id": 31,
      "Start": now,
      "End": tommorow,
      "isAllDay": false,
      "resourceNo": "VH-386-DB",
      "Title": "Event 1",
      "recurrenceRule": null,
      "TaskID": guid()
    },
    {
      "id": 32,
      "Start": new Date(now.setHours(0,0,0,0)),
      "End": tommorow,
      "isAllDay": false,
      "resourceNo": "VH-387-DB",
      "Title": "Event 2",
      "recurrenceRule": null,
      "TaskID": guid()
    },
    {
      "id": 33,
      "Start": now,
      "End": tommorow,
      "isAllDay": false,
      "resourceNo": "VH-388-DB",
      "Title": "Event 3",
      "recurrenceRule": null,
      "TaskID": guid()
    },
    {
      "id": 34,
      "Start": new Date(now.setHours(10,0,0,0)),
      "End": tommorow,
      "isAllDay": false,
      "resourceNo": "VH-389-DB",
      "Title": "Event 4",
      "recurrenceRule": null,
      "TaskID": guid()
    },
    {
      "id": 35,
      "Start": now,
      "End": tommorow,
      "isAllDay": false,
      "resourceNo": "VH-390-DB",
      "Title": "Event 5",
      "recurrenceRule": null,
      "TaskID": guid()
    },
    {
      "id": 36,
      "Start": new Date(now.setHours(20,0,0,0)),
      "End": tommorow,
      "isAllDay": false,
      "resourceNo": "VH-391-DB",
      "Title": "Event 6",
      "recurrenceRule": null,
      "TaskID": guid()
    },
    {
      "id": 37,
      "Start": new Date(now.setHours(5,0,0,0)),
      "End": tommorow,
      "isAllDay": false,
      "resourceNo": "VH-392-DB",
      "Title": "Event 7",
      "recurrenceRule": null,
      "TaskID": guid()
    },
    {
      "id": 38,
      "Start": now,
      "End": tommorow,
      "isAllDay": false,
      "resourceNo": "VH-393-DB",
      "Title": "Event 8",
      "recurrenceRule": null,
      "TaskID": guid()
    },
    {
      "id": 39,
      "Start": new Date(now.setHours(10,0,0,0)),
      "End": tommorow,
      "isAllDay": false,
      "resourceNo": "VH-394-DB",
      "Title": "Event 9",
      "recurrenceRule": null,
      "TaskID": guid()
    },
    {
      "id": 40,
      "Start": now,
      "End": tommorow,
      "isAllDay": false,
      "resourceNo": "VH-395-DB",
      "Title": "Event 10",
      "recurrenceRule": null,
      "TaskID": guid()
    },
    {
      "id": 41,
      "Start": new Date(now.setHours(5,0,0,0)),
      "End": new Date(now.setHours(10,0,0,0)),
      "isAllDay": false,
      "resourceNo": "VH-396-DB",
      "Title": "Event 1",
      "recurrenceRule": null,
      "TaskID": guid()
    },
    {
      "id": 42,
      "Start": now,
      "End": tommorow,
      "isAllDay": false,
      "resourceNo": "VH-397-DB",
      "Title": "Event 2",
      "recurrenceRule": null,
      "TaskID": guid()
    },
    {
      "id": 43,
      "Start": now,
      "End": tommorow,
      "isAllDay": false,
      "resourceNo": "VH-398-DB",
      "Title": "Event 3",
      "recurrenceRule": null,
      "TaskID": guid()
    },
    {
      "id": 44,
      "Start": new Date(now.setHours(0,0,0,0)),
      "End": tommorow,
      "isAllDay": false,
      "resourceNo": "VH-399-DB",
      "Title": "Event 4",
      "recurrenceRule": null,
      "TaskID": guid()
    },
    {
      "id": 45,
      "Start": new Date(now.setHours(0,0,0,0)),
      "End": tommorow,
      "isAllDay": false,
      "resourceNo": "VH-400-DB",
      "Title": "Event 5",
      "recurrenceRule": null,
      "TaskID": guid()
    },
    {
      "id": 46,
      "Start": new Date(now.setHours(10,0,0,0)),
      "End": tommorow,
      "isAllDay": false,
      "resourceNo": "VH-401-DB",
      "Title": "Event 6",
      "recurrenceRule": null,
      "TaskID": guid()
    },
    {
      "id": 47,
      "Start": new Date(now.setHours(0,0,0,0)),
      "End": tommorow,
      "isAllDay": false,
      "resourceNo": "VH-402-DB",
      "Title": "Event 7",
      "recurrenceRule": null,
      "TaskID": guid()
    },
    {
      "id": 48,
      "Start": now,
      "End": tommorow,
      "isAllDay": false,
      "resourceNo": "VH-403-DB",
      "Title": "Event 8",
      "recurrenceRule": null,
      "TaskID": guid()
    },
    {
      "id": 49,
      "Start": new Date(now.setHours(0,0,0,0)),
      "End": tommorow,
      "isAllDay": false,
      "resourceNo": "VH-404-DB",
      "Title": "Event 9",
      "recurrenceRule": null,
      "TaskID": guid()
    },
    {
      "id": 50,
      "Start": now,
      "End": tommorow,
      "isAllDay": false,
      "resourceNo": "VH-405-DB",
      "Title": "Event 10",
      "recurrenceRule": null,
      "TaskID": guid()
    }
  ] 
  export const kendoResourceData = [
    {
      "id": 1,
      "Start": now,
      "End": tommorow,
      "isAllDay": false,
      "resourceNo": "VH-356-DB",
      "Title": "Event 1",
      "recurrenceRule": null,
      "TaskID": guid(),
      "groupId":1
    },
    {
      "id": 2,
      "Start": "2023-12-31T21:30:00.000Z",
      "End": "2023-12-31T22:30:00.000Z",
      "isAllDay": false,
      "resourceNo": "VH-357-DB",
      "Title": "Event 2",
      "recurrenceRule": null,
      "TaskID": guid(),
      "groupId":1
    },
    {
      "id": 3,
      "Start": "2023-12-31T21:30:00.000Z",
      "End": "2023-12-31T22:30:00.000Z",
      "isAllDay": false,
      "resourceNo": "VH-358-DB",
      "Title": "Event 3",
      "recurrenceRule": null,
      "TaskID": guid(),
      "groupId":1
    },
    {
      "id": 4,
      "Start": "2023-12-31T21:30:00.000Z",
      "End": "2023-12-31T22:30:00.000Z",
      "isAllDay": false,
      "resourceNo": "VH-359-DB",
      "Title": "Event 4",
      "recurrenceRule": null,
      "TaskID": guid(),
      "groupId":1
    },
    {
      "id": 5,
      "Start": "2023-12-31T21:30:00.000Z",
      "End": "2023-12-31T22:30:00.000Z",
      "isAllDay": false,
      "resourceNo": "VH-360-DB",
      "Title": "Event 5",
      "recurrenceRule": null,
      "TaskID": guid(),
      "groupId":1
    },
    {
      "id": 6,
      "Start": "2023-12-31T21:30:00.000Z",
      "End": "2023-12-31T22:30:00.000Z",
      "isAllDay": false,
      "resourceNo": "VH-361-DB",
      "Title": "Event 6",
      "recurrenceRule": null,
      "TaskID": guid(),
      "groupId":1
    },
    {
      "id": 7,
      "Start": "2023-12-31T21:30:00.000Z",
      "End": "2023-12-31T22:30:00.000Z",
      "isAllDay": false,
      "resourceNo": "VH-362-DB",
      "Title": "Event 7",
      "recurrenceRule": null,
      "TaskID": guid(),
      "groupId":1
    },
    {
      "id": 8,
      "Start": "2023-12-31T21:30:00.000Z",
      "End": "2023-12-31T22:30:00.000Z",
      "isAllDay": false,
      "resourceNo": "VH-363-DB",
      "Title": "Event 8",
      "recurrenceRule": null,
      "TaskID": guid(),
      "groupId":1
    },
    {
      "id": 9,
      "Start": "2023-12-31T21:30:00.000Z",
      "End": "2023-12-31T22:30:00.000Z",
      "isAllDay": false,
      "resourceNo": "VH-364-DB",
      "Title": "Event 9",
      "recurrenceRule": null,
      "TaskID": guid(),
      "groupId":1
    },
    {
      "id": 10,
      "Start": "2023-12-31T21:30:00.000Z",
      "End": "2023-12-31T22:30:00.000Z",
      "isAllDay": false,
      "resourceNo": "VH-365-DB",
      "Title": "Event 10",
      "recurrenceRule": null,
      "TaskID": guid(),
      "groupId":1
    },
    {
      "id": 11,
      "Start": "2023-12-31T21:30:00.000Z",
      "End": "2023-12-31T22:30:00.000Z",
      "isAllDay": false,
      "resourceNo": "VH-366-DB",
      "Title": "Event 1",
      "recurrenceRule": null,
      "TaskID": guid(),
      "groupId":1
    },
    {
      "id": 12,
      "Start": "2023-12-31T21:30:00.000Z",
      "End": "2023-12-31T22:30:00.000Z",
      "isAllDay": false,
      "resourceNo": "VH-367-DB",
      "Title": "Event 2",
      "recurrenceRule": null,
      "TaskID": guid(),
      "groupId":1
    },
    {
      "id": 13,
      "Start": "2023-12-31T21:30:00.000Z",
      "End": "2023-12-31T22:30:00.000Z",
      "isAllDay": false,
      "resourceNo": "VH-368-DB",
      "Title": "Event 3",
      "recurrenceRule": null,
      "TaskID": guid(),
      "groupId":1
    },
    {
      "id": 14,
      "Start": "2023-12-31T21:30:00.000Z",
      "End": "2023-12-31T22:30:00.000Z",
      "isAllDay": false,
      "resourceNo": "VH-369-DB",
      "Title": "Event 4",
      "recurrenceRule": null,
      "TaskID": guid(),
      "groupId":1
    },
    {
      "id": 15,
      "Start": "2023-12-31T21:30:00.000Z",
      "End": "2023-12-31T22:30:00.000Z",
      "isAllDay": false,
      "resourceNo": "VH-370-DB",
      "Title": "Event 5",
      "recurrenceRule": null,
      "TaskID": guid(),
      "groupId":1
    },
    {
      "id": 16,
      "Start": "2023-12-31T21:30:00.000Z",
      "End": "2023-12-31T22:30:00.000Z",
      "isAllDay": false,
      "resourceNo": "VH-371-DB",
      "Title": "Event 6",
      "recurrenceRule": null,
      "TaskID": guid(),
      "groupId":2
    },
    {
      "id": 17,
      "Start": "2023-12-31T21:30:00.000Z",
      "End": "2023-12-31T22:30:00.000Z",
      "isAllDay": false,
      "resourceNo": "VH-372-DB",
      "Title": "Event 7",
      "recurrenceRule": null,
      "TaskID": guid(),
      "groupId":2
    },
    {
      "id": 18,
      "Start": "2023-12-31T21:30:00.000Z",
      "End": "2023-12-31T22:30:00.000Z",
      "isAllDay": false,
      "resourceNo": "VH-373-DB",
      "Title": "Event 8",
      "recurrenceRule": null,
      "TaskID": guid(),
      "groupId":2
    },
    {
      "id": 19,
      "Start": "2023-12-31T21:30:00.000Z",
      "End": "2023-12-31T22:30:00.000Z",
      "isAllDay": false,
      "resourceNo": "VH-374-DB",
      "Title": "Event 9",
      "recurrenceRule": null,
      "TaskID": guid(),
      "groupId":2
    },
    {
      "id": 20,
      "Start": "2023-12-31T21:30:00.000Z",
      "End": "2023-12-31T22:30:00.000Z",
      "isAllDay": false,
      "resourceNo": "VH-375-DB",
      "Title": "Event 10",
      "recurrenceRule": null,
      "TaskID": guid(),
      "groupId":2
    },
    {
      "id": 21,
      "Start": "2023-12-31T21:30:00.000Z",
      "End": "2023-12-31T22:30:00.000Z",
      "isAllDay": false,
      "resourceNo": "VH-376-DB",
      "Title": "Event 1",
      "recurrenceRule": null,
      "TaskID": guid(),
      "groupId":2
    },
    {
      "id": 22,
      "Start": "2023-12-31T21:30:00.000Z",
      "End": "2023-12-31T22:30:00.000Z",
      "isAllDay": false,
      "resourceNo": "VH-377-DB",
      "Title": "Event 2",
      "recurrenceRule": null,
      "TaskID": guid(),
      "groupId":2
    },
    {
      "id": 23,
      "Start": "2023-12-31T21:30:00.000Z",
      "End": "2023-12-31T22:30:00.000Z",
      "isAllDay": false,
      "resourceNo": "VH-378-DB",
      "Title": "Event 3",
      "recurrenceRule": null,
      "TaskID": guid(),
      "groupId":2
    },
    {
      "id": 24,
      "Start": "2023-12-31T21:30:00.000Z",
      "End": "2023-12-31T22:30:00.000Z",
      "isAllDay": false,
      "resourceNo": "VH-379-DB",
      "Title": "Event 4",
      "recurrenceRule": null,
      "TaskID": guid(),
      "groupId":2
    },
    {
      "id": 25,
      "Start": "2023-12-31T21:30:00.000Z",
      "End": "2023-12-31T22:30:00.000Z",
      "isAllDay": false,
      "resourceNo": "VH-380-DB",
      "Title": "Event 5",
      "recurrenceRule": null,
      "TaskID": guid(),
      "groupId":2
    },
    {
      "id": 26,
      "Start": "2023-12-31T21:30:00.000Z",
      "End": "2023-12-31T22:30:00.000Z",
      "isAllDay": false,
      "resourceNo": "VH-381-DB",
      "Title": "Event 6",
      "recurrenceRule": null,
      "TaskID": guid(),
      "groupId":2
    },
    {
      "id": 27,
      "Start": "2023-12-31T21:30:00.000Z",
      "End": "2023-12-31T22:30:00.000Z",
      "isAllDay": false,
      "resourceNo": "VH-382-DB",
      "Title": "Event 7",
      "recurrenceRule": null,
      "TaskID": guid(),
      "groupId":2
    },
    {
      "id": 28,
      "Start": "2023-12-31T21:30:00.000Z",
      "End": "2023-12-31T22:30:00.000Z",
      "isAllDay": false,
      "resourceNo": "VH-383-DB",
      "Title": "Event 8",
      "recurrenceRule": null,
      "TaskID": guid(),
      "groupId":2
    },
    {
      "id": 29,
      "Start": "2023-12-31T21:30:00.000Z",
      "End": "2023-12-31T22:30:00.000Z",
      "isAllDay": false,
      "resourceNo": "VH-384-DB",
      "Title": "Event 9",
      "recurrenceRule": null,
      "TaskID": guid(),
      "groupId":2
    },
    {
      "id": 30,
      "Start": "2023-12-31T21:30:00.000Z",
      "End": "2023-12-31T22:30:00.000Z",
      "isAllDay": false,
      "resourceNo": "VH-385-DB",
      "Title": "Event 10",
      "recurrenceRule": null,
      "TaskID": guid(),
      "groupId":2
    },
    {
      "id": 31,
      "Start": "2023-12-31T21:30:00.000Z",
      "End": "2023-12-31T22:30:00.000Z",
      "isAllDay": false,
      "resourceNo": "VH-386-DB",
      "Title": "Event 1",
      "recurrenceRule": null,
      "TaskID": guid(),
      "groupId":3
    },
    {
      "id": 32,
      "Start": "2023-12-31T21:30:00.000Z",
      "End": "2023-12-31T22:30:00.000Z",
      "isAllDay": false,
      "resourceNo": "VH-387-DB",
      "Title": "Event 2",
      "recurrenceRule": null,
      "TaskID": guid(),
      "groupId":3
    },
    {
      "id": 33,
      "Start": "2023-12-31T21:30:00.000Z",
      "End": "2023-12-31T22:30:00.000Z",
      "isAllDay": false,
      "resourceNo": "VH-388-DB",
      "Title": "Event 3",
      "recurrenceRule": null,
      "TaskID": guid(),
      "groupId":3
    },
    {
      "id": 34,
      "Start": "2023-12-31T21:30:00.000Z",
      "End": "2023-12-31T22:30:00.000Z",
      "isAllDay": false,
      "resourceNo": "VH-389-DB",
      "Title": "Event 4",
      "recurrenceRule": null,
      "TaskID": guid(),
      "groupId":3
    },
    {
      "id": 35,
      "Start": "2023-12-31T21:30:00.000Z",
      "End": "2023-12-31T22:30:00.000Z",
      "isAllDay": false,
      "resourceNo": "VH-390-DB",
      "Title": "Event 5",
      "recurrenceRule": null,
      "TaskID": guid(),
      "groupId":3
    },
    {
      "id": 36,
      "Start": "2023-12-31T21:30:00.000Z",
      "End": "2023-12-31T22:30:00.000Z",
      "isAllDay": false,
      "resourceNo": "VH-391-DB",
      "Title": "Event 6",
      "recurrenceRule": null,
      "TaskID": guid(),
      "groupId":3
    },
    {
      "id": 37,
      "Start": "2023-12-31T21:30:00.000Z",
      "End": "2023-12-31T22:30:00.000Z",
      "isAllDay": false,
      "resourceNo": "VH-392-DB",
      "Title": "Event 7",
      "recurrenceRule": null,
      "TaskID": guid(),
      "groupId":3
    },
    {
      "id": 38,
      "Start": "2023-12-31T21:30:00.000Z",
      "End": "2023-12-31T22:30:00.000Z",
      "isAllDay": false,
      "resourceNo": "VH-393-DB",
      "Title": "Event 8",
      "recurrenceRule": null,
      "TaskID": guid(),
      "groupId":3
    },
    {
      "id": 39,
      "Start": "2023-12-31T21:30:00.000Z",
      "End": "2023-12-31T22:30:00.000Z",
      "isAllDay": false,
      "resourceNo": "VH-394-DB",
      "Title": "Event 9",
      "recurrenceRule": null,
      "TaskID": guid(),
      "groupId":3
    },
    {
      "id": 40,
      "Start": "2023-12-31T21:30:00.000Z",
      "End": "2023-12-31T22:30:00.000Z",
      "isAllDay": false,
      "resourceNo": "VH-395-DB",
      "Title": "Event 10",
      "recurrenceRule": null,
      "TaskID": guid(),
      "groupId":3
    },
    {
      "id": 41,
      "Start": "2023-12-31T21:30:00.000Z",
      "End": "2023-12-31T22:30:00.000Z",
      "isAllDay": false,
      "resourceNo": "VH-396-DB",
      "Title": "Event 1",
      "recurrenceRule": null,
      "TaskID": guid(),
      "groupId":3
    },
    {
      "id": 42,
      "Start": "2023-12-31T21:30:00.000Z",
      "End": "2023-12-31T22:30:00.000Z",
      "isAllDay": false,
      "resourceNo": "VH-397-DB",
      "Title": "Event 2",
      "recurrenceRule": null,
      "TaskID": guid(),
      "groupId":3
    },
    {
      "id": 43,
      "Start": "2023-12-31T21:30:00.000Z",
      "End": "2023-12-31T22:30:00.000Z",
      "isAllDay": false,
      "resourceNo": "VH-398-DB",
      "Title": "Event 3",
      "recurrenceRule": null,
      "TaskID": guid(),
      "groupId":3
    },
    {
      "id": 44,
      "Start": "2023-12-31T21:30:00.000Z",
      "End": "2023-12-31T22:30:00.000Z",
      "isAllDay": false,
      "resourceNo": "VH-399-DB",
      "Title": "Event 4",
      "recurrenceRule": null,
      "TaskID": guid(),
      "groupId":3
    },
    {
      "id": 45,
      "Start": "2023-12-31T21:30:00.000Z",
      "End": "2023-12-31T22:30:00.000Z",
      "isAllDay": false,
      "resourceNo": "VH-400-DB",
      "Title": "Event 5",
      "recurrenceRule": null,
      "TaskID": guid(),
      "groupId":3
    },
    {
      "id": 46,
      "Start": "2023-12-31T21:30:00.000Z",
      "End": "2023-12-31T22:30:00.000Z",
      "isAllDay": false,
      "resourceNo": "VH-401-DB",
      "Title": "Event 6",
      "recurrenceRule": null,
      "TaskID": guid(),
      "groupId":3
    },
    {
      "id": 47,
      "Start": "2023-12-31T21:30:00.000Z",
      "End": "2023-12-31T22:30:00.000Z",
      "isAllDay": false,
      "resourceNo": "VH-402-DB",
      "Title": "Event 7",
      "recurrenceRule": null,
      "TaskID": guid(),
      "groupId":3
    },
    {
      "id": 48,
      "Start": "2023-12-31T21:30:00.000Z",
      "End": "2023-12-31T22:30:00.000Z",
      "isAllDay": false,
      "resourceNo": "VH-403-DB",
      "Title": "Event 8",
      "recurrenceRule": null,
      "TaskID": guid(),
      "groupId":3
    },
    {
      "id": 49,
      "Start": "2023-12-31T21:30:00.000Z",
      "End": "2023-12-31T22:30:00.000Z",
      "isAllDay": false,
      "resourceNo": "VH-404-DB",
      "Title": "Event 9",
      "recurrenceRule": null,
      "TaskID": guid(),
      "groupId":3
    },
    {
      "id": 50,
      "Start": "2023-12-31T21:30:00.000Z",
      "End": "2023-12-31T22:30:00.000Z",
      "isAllDay": false,
      "resourceNo": "VH-405-DB",
      "Title": "Event 10",
      "recurrenceRule": null,
      "TaskID": guid(),
      "groupId":3
    }
  ] 

  export const msEventData = [
    {
      id: guid(),
      start: now.setHours(5, 0, 0, 0),
      end: now.setHours(6, 0, 0, 0),
      title: 'Event 9',
      resource: 'v2',
      tripNo: 'T001269',
      actionCode: LOAD,
      city: 'Audruicq',
      shortCity:'ADR',
      addresscode: 'ADR-0008173',
      addressname: 'Address 20',
      address: 'Street 61',
      postCode: '849',
      startingDate: 1714608000000,
      startingTime: '08:00:00',
      endingTime: '01:00'
    },
    {
      id: guid(),
      start: now.setHours(1, 0, 0, 0),
      end: now.setHours(3, 0, 0, 0),
      title: 'Event 9',
      resource: 'v2',
      tripNo: 'T007413',
      actionCode: LOAD,
      city: 'Audruicq',
      shortCity:'ADR',
      addresscode: 'ADR-0008173',
      addressname: 'Address 20',
      address: 'Street 61',
      postCode: '849',
      startingDate: 1714608000000,
      startingTime: '08:00:00',
      endingTime: '01:00',
      isAgendaItem:true,
      agendaItemType:{ text: "Inspection" }
    },
    {
      id: guid(),
      start: now.setHours(7, 0, 0, 0),
      end: now.setHours(8, 0, 0, 0),
      title: 'Event 9',
      resource: 'v2',
      tripNo: 'T001269',
      actionCode: FERRYON,
      city: 'Calais',
      shortCity:'CLS',
      addresscode: 'ADR-0008173',
      addressname: 'Address 20',
      address: 'Street 61',
      postCode: '849',
      startingDate: 1714608000000,
      startingTime: '08:00:00',
      endingTime: '01:00'
    },
    {
      id: guid(),
      start: now.setHours(10, 0, 0, 0),
      end: now.setHours(11, 0, 0, 0),
      title: 'Event 9',
      resource: 'v2',
      tripNo: 'T001269',
      actionCode: FERRYOF,
      city: 'Dover',
      shortCity:'DVR',
      addresscode: 'ADR-0008173',
      addressname: 'Address 20',
      address: 'Street 61',
      postCode: '849',
      startingDate: 1714608000000,
      startingTime: '08:00:00',
      endingTime: '01:00'
    },
    {
      id: guid(),
      start: now.setHours(13, 0, 0, 0),
      end: now.setHours(14, 0, 0, 0),
      title: 'Event 10',
      resource: 'v2',
      tripNo: 'T001269',
      actionCode: 'UNLOAD',
      city: 'Canterbury',
      shortCity:'CNB',
      addresscode: 'ADR-000520',
      addressname: 'Address 22',
      address: 'Street 58',
      postCode: '6570',
      startingDate: 1714608000000,
      startingTime: '13:00:00',
      endingTime: '02:00'
    },
    {
      id: guid(),
      start: now.setHours(15, 0, 0, 0),
      end: now.setHours(16, 30, 0, 0),
      title: 'Event 3',
      resource: 'v2',
      tripNo: 'T001270',
      actionCode: 'LOAD',
      city: 'Eindhoven',
      shortCity:"EDV",
      addresscode: 'ADR-0009050',
      addressname: 'Address 53',
      address: 'Street 33',
      postCode: '3396',
      startingDate: 1714608000000,
      startingTime: '08:00:00',
      endingTime: '01:00'
    },
    {
      id: guid(),
      start: now.setHours(18, 0, 0, 0),
      end: now.setHours(19, 30, 0, 0),
      title: 'Event 4',
      resource: 'v2',
      tripNo: 'T001270',
      actionCode: 'UNLOAD',
      city: 'Namur',
      shortCity:'WNA',
      addresscode: 'ADR-0004625',
      addressname: 'Address 86',
      address: 'Street 15',
      postCode: '276',
      startingDate: 1714608000000,
      startingTime: '13:00:00',
      endingTime: '02:00'
    },
    {
      id: guid(),
      start: now.setHours(9, 30, 0, 0),
      end: now.setHours(11, 0, 0, 0),
      title: 'Event 5',
      resource: 'v3',
      tripNo: 'T001271',
      actionCode: 'LOADDEPOT',
      city: 'Brussels',
      shortCity:'BRU',
      addresscode: 'ADR-0009685',
      addressname: 'Address 36',
      address: 'Street 32',
      postCode: '8435',
      startingDate: 1714608000000,
      startingTime: '08:00:00',
      endingTime: '01:00'
    },
    {
      id: guid(),
      start: now.setHours(12, 30, 0, 0),
      end: now.setHours(14, 0, 0, 0),
      title: 'Event 6',
      resource: 'v3',
      tripNo: 'T001271',
      actionCode: 'UNLOAD',
      city: 'Antwerp',
      shortCity:"ANR",
      addresscode: 'ADR-0002883',
      addressname: 'Address 52',
      address: 'Street 47',
      postCode: '504',
      startingDate: 1714608000000,
      startingTime: '13:00:00',
      endingTime: '02:00'
    },
    {
      id: guid(),
      start: now.setHours(16, 30, 0, 0),
      end: now.setHours(18, 0, 0, 0),
      title: 'Event 6',
      resource: 'v3',
      tripNo: 'T001271',
      actionCode: 'UNLOAD',
      city: 'Leiden',
      shortCity:"LEI",
      addresscode: 'ADR-0002883',
      addressname: 'Address 52',
      address: 'Street 47',
      postCode: '504',
      startingDate: 1714608000000,
      startingTime: '13:00:00',
      endingTime: '02:00'
    },
    {
      id: guid(),
      start: now.setHours(20, 30, 0, 0),
      end: now.setHours(22, 0, 0, 0),
      title: 'Event 6',
      resource: 'v3',
      tripNo: 'T001271',
      actionCode: 'UNLOAD',
      city: 'Gouda',
      shortCity:"GOU",
      addresscode: 'ADR-0002883',
      addressname: 'Address 52',
      address: 'Street 47',
      postCode: '504',
      startingDate: 1714608000000,
      startingTime: '13:00:00',
      endingTime: '02:00'
    },
    {
      id: guid(),
      start: now.setHours(23, 0, 0, 0),
      end: tommorow.setHours(0, 30, 0, 0),
      title: 'Event 6',
      resource: 'v3',
      tripNo: 'T001271',
      actionCode: 'UNLOAD',
      city: 'Antwerp',
      shortCity:"ANR",
      addresscode: 'ADR-0002883',
      addressname: 'Address 52',
      address: 'Street 47',
      postCode: '504',
      startingDate: 1714608000000,
      startingTime: '13:00:00',
      endingTime: '02:00'
    },
    {
      id: guid(),
      start: tommorow.setHours(2, 30, 0, 0),
      end: tommorow.setHours(4, 0, 0, 0),
      title: 'Event 6',
      resource: 'v3',
      tripNo: 'T001271',
      actionCode: 'UNLOAD',
      city: 'Kortrijk',
      shortCity:"KVK",
      addresscode: 'ADR-0002883',
      addressname: 'Address 52',
      address: 'Street 47',
      postCode: '504',
      startingDate: 1714608000000,
      startingTime: '13:00:00',
      endingTime: '02:00'
    },
    {
      id: guid(),
      start: tommorow.setHours(5, 0, 0, 0),
      end: tommorow.setHours(6, 0, 0, 0),
      title: 'Event 6',
      resource: 'v3',
      tripNo: 'T001271',
      actionCode: 'UNLOAD',
      city: 'Breda',
      shortCity:"BRE",
      addresscode: 'ADR-0002883',
      addressname: 'Address 52',
      address: 'Street 47',
      postCode: '504',
      startingDate: 1714608000000,
      startingTime: '13:00:00',
      endingTime: '02:00'
    },
    {
      id: guid(),
      start: now.setHours(3, 0, 0, 0),
      end: now.setHours(4, 0, 0, 0),
      title: 'Event 7',
      resource: 'v4',
      tripNo: 'T001272',
      actionCode: LOADDEPOT,
      city: 'Brussels',
      shortCity:'BRU',
      addresscode: 'ADR-0008111',
      addressname: 'Address 5',
      address: 'Street 36',
      postCode: '6888',
      startingDate: 1714608000000,
      startingTime: '08:00:00',
      endingTime: '01:00'
    },
    {
      id: guid(),
      start: now.setHours(5, 0, 0, 0),
      end: now.setHours(6, 0, 0, 0),
      title: 'Event 7',
      resource: 'v4',
      tripNo: 'T001272',
      actionCode: UNLOAD,
      city: 'Breda',
      shortCity:'BRE',
      addresscode: 'ADR-0008111',
      addressname: 'Address 5',
      address: 'Street 36',
      postCode: '6888',
      startingDate: 1714608000000,
      startingTime: '08:00:00',
      endingTime: '01:00'
    },
    {
      id: guid(),
      start: now.setHours(7, 0, 0, 0),
      end: now.setHours(8, 0, 0, 0),
      title: 'Event 8',
      resource: 'v4',
      tripNo: 'T001272',
      actionCode: UNLOAD,
      city: 'Antwerp',
      shortCity:'ANR',
      addresscode: 'ADR-0006550',
      addressname: 'Address 54',
      address: 'Street 86',
      postCode: '5775',
      startingDate: 1714608000000,
      startingTime: '13:00:00',
      endingTime: '02:00'
    },
    {
      id: guid(),
      start: now.setHours(9, 0, 0, 0),
      end: now.setHours(10, 0, 0, 0),
      title: 'Event 8',
      resource: 'v4',
      tripNo: 'T001272',
      actionCode: UNLOAD,
      city: 'Ghent',
      shortCity:'GHE',
      addresscode: 'ADR-0006550',
      addressname: 'Address 54',
      address: 'Street 86',
      postCode: '5775',
      startingDate: 1714608000000,
      startingTime: '13:00:00',
      endingTime: '02:00'
    },
    {
      id: guid(),
      start: now.setHours(11, 0, 0, 0),
      end: now.setHours(12, 0, 0, 0),
      title: 'Event 8',
      resource: 'v4',
      tripNo: 'T001272',
      actionCode: LOAD,
      city: 'Namur',
      shortCity:'WNA',
      addresscode: 'ADR-0006550',
      addressname: 'Address 54',
      address: 'Street 86',
      postCode: '5775',
      startingDate: 1714608000000,
      startingTime: '13:00:00',
      endingTime: '02:00'
    },
    {
      id: guid(),
      start: now.setHours(13, 0, 0, 0),
      end: now.setHours(14, 0, 0, 0),
      title: 'Event 8',
      resource: 'v4',
      tripNo: 'T001272',
      actionCode: UNLOADDEPOT,
      city: 'Kortrijk',
      shortCity:'KVK',
      addresscode: 'ADR-0006550',
      addressname: 'Address 54',
      address: 'Street 86',
      postCode: '5775',
      startingDate: 1714608000000,
      startingTime: '13:00:00',
      endingTime: '02:00'
    },
    {
      id: guid(),
      start: now.setHours(5, 0, 0, 0),
      end: now.setHours(6, 0, 0, 0),
      title: 'Event 9',
      resource: 'v5',
      tripNo: 'T001273',
      actionCode: LOAD,
      city: 'Audruicq',
      shortCity:'ADR',
      addresscode: 'ADR-0008173',
      addressname: 'Address 20',
      address: 'Street 61',
      postCode: '849',
      startingDate: 1714608000000,
      startingTime: '08:00:00',
      endingTime: '01:00'
    },
    {
      id: guid(),
      start: now.setHours(7, 0, 0, 0),
      end: now.setHours(8, 0, 0, 0),
      title: 'Event 9',
      resource: 'v5',
      tripNo: 'T001273',
      actionCode: FERRYON,
      city: 'Calais',
      shortCity:'CLS',
      addresscode: 'ADR-0008173',
      addressname: 'Address 20',
      address: 'Street 61',
      postCode: '849',
      startingDate: 1714608000000,
      startingTime: '08:00:00',
      endingTime: '01:00'
    },
    {
      id: guid(),
      start: now.setHours(10, 0, 0, 0),
      end: now.setHours(11, 0, 0, 0),
      title: 'Event 9',
      resource: 'v5',
      tripNo: 'T001273',
      actionCode: FERRYOF,
      city: 'Dover',
      shortCity:'DVR',
      addresscode: 'ADR-0008173',
      addressname: 'Address 20',
      address: 'Street 61',
      postCode: '849',
      startingDate: 1714608000000,
      startingTime: '08:00:00',
      endingTime: '01:00'
    },
    {
      id: guid(),
      start: now.setHours(13, 0, 0, 0),
      end: now.setHours(14, 0, 0, 0),
      title: 'Event 10',
      resource: 'v5',
      tripNo: 'T001273',
      actionCode: 'UNLOAD',
      city: 'Canterbury',
      shortCity:'CNB',
      addresscode: 'ADR-000520',
      addressname: 'Address 22',
      address: 'Street 58',
      postCode: '6570',
      startingDate: 1714608000000,
      startingTime: '13:00:00',
      endingTime: '02:00'
    },
    {
      id: guid(),
      start: now.setHours(16, 0, 0, 0),
      end: now.setHours(17, 0, 0, 0),
      title: 'Event 7',
      resource: 's2',
      tripNo: 'T0012922',
      actionCode: LOADDEPOT,
      city: 'Brussels',
      shortCity:'BRU',
      addresscode: 'ADR-0008111',
      addressname: 'Address 5',
      address: 'Street 36',
      postCode: '6888',
      startingDate: 1714608000000,
      startingTime: '08:00:00',
      endingTime: '01:00'
    },
    {
      id: guid(),
      start: now.setHours(20, 0, 0, 0),
      end: now.setHours(21, 0, 0, 0),
      title: 'Event 7',
      resource: 's2',
      tripNo: 'T0012922',
      actionCode: UNLOAD,
      city: 'Breda',
      shortCity:'BRE',
      addresscode: 'ADR-0008111',
      addressname: 'Address 5',
      address: 'Street 36',
      postCode: '6888',
      startingDate: 1714608000000,
      startingTime: '08:00:00',
      endingTime: '01:00'
    },
    {
      id: guid(),
      start: now.setHours(23, 0, 0, 0),
      end: tommorow.setHours(0, 0, 0, 0),
      title: 'Event 8',
      resource: 's2',
      tripNo: 'T0012922',
      actionCode: UNLOAD,
      city: 'Antwerp',
      shortCity:'ANR',
      addresscode: 'ADR-0006550',
      addressname: 'Address 54',
      address: 'Street 86',
      postCode: '5775',
      startingDate: 1714608000000,
      startingTime: '13:00:00',
      endingTime: '02:00'
    },
    {
      id: guid(),
      start: tommorow.setHours(3, 0, 0, 0),
      end: tommorow.setHours(4, 0, 0, 0),
      title: 'Event 8',
      resource: 's2',
      tripNo: 'T0012922',
      actionCode: UNLOAD,
      city: 'Ghent',
      shortCity:'GHE',
      addresscode: 'ADR-0006550',
      addressname: 'Address 54',
      address: 'Street 86',
      postCode: '5775',
      startingDate: 1714608000000,
      startingTime: '13:00:00',
      endingTime: '02:00'
    },
    {
      id: guid(),
      start: tommorow.setHours(6, 0, 0, 0),
      end: tommorow.setHours(7, 0, 0, 0),
      title: 'Event 8',
      resource: 's2',
      tripNo: 'T0012922',
      actionCode: LOAD,
      city: 'Namur',
      shortCity:'WNA',
      addresscode: 'ADR-0006550',
      addressname: 'Address 54',
      address: 'Street 86',
      postCode: '5775',
      startingDate: 1714608000000,
      startingTime: '13:00:00',
      endingTime: '02:00'
    },
    {
      id: guid(),
      start: tommorow.setHours(9, 0, 0, 0),
      end: tommorow.setHours(10, 0, 0, 0),
      title: 'Event 8',
      resource: 's2',
      tripNo: 'T0012922',
      actionCode: UNLOADDEPOT,
      city: 'Kortrijk',
      shortCity:'KVK',
      addresscode: 'ADR-0006550',
      addressname: 'Address 54',
      address: 'Street 86',
      postCode: '5775',
      startingDate: 1714608000000,
      startingTime: '13:00:00',
      endingTime: '02:00'
    },
    {
      id: guid(),
      start: now.setHours(6, 0, 0, 0),
      end: now.setHours(7, 0, 0, 0),
      title: 'Event 11',
      resource: 'v6',
      tripNo: 'T001274',
      actionCode: 'LOAD',
      city: 'Ostend',
      shortCity:'OSD',
      addresscode: 'ADR-0008268',
      addressname: 'Address 8',
      address: 'Street 16',
      postCode: '7084',
      startingDate: 1714608000000,
      startingTime: '08:00:00',
      endingTime: '01:00'
    },
    {
      id: guid(),
      start: now.setHours(10, 0, 0, 0),
      end: now.setHours(11, 0, 0, 0),
      title: 'Event 12',
      resource: 'v6',
      tripNo: 'T001274',
      actionCode: 'UNLOAD',
      city: 'Brussels',
      shortCity:'BRU',
      addresscode: 'ADR-0005773',
      addressname: 'Address 61',
      address: 'Street 25',
      postCode: '6176',
      startingDate: 1714608000000,
      startingTime: '13:00:00',
      endingTime: '02:00'
    },
    {
      id: guid(),
      start: now.setHours(12, 0, 0, 0),
      end: now.setHours(13, 0, 0, 0),
      title: 'Event 11',
      resource: 'v6',
      tripNo: 'T0012749',
      actionCode: LOAD,
      city: 'Brussel',
      shortCity:'BRU',
      addresscode: 'ADR-0008268',
      addressname: 'Address 8',
      address: 'Street 16',
      postCode: '7084',
      startingDate: 1714608000000,
      startingTime: '08:00:00',
      endingTime: '01:00'
    },
    {
      id: guid(),
      start: now.setHours(15, 0, 0, 0),
      end: now.setHours(16, 0, 0, 0),
      title: 'Event 11',
      resource: 'v6',
      tripNo: 'T0012749',
      actionCode: HOOKOF,
      city: 'Antwerp',
      shortCity:'ANR',
      addresscode: 'ADR-0008268',
      addressname: 'Address 8',
      address: 'Street 16',
      postCode: '7084',
      startingDate: 1714608000000,
      startingTime: '08:00:00',
      endingTime: '01:00'
    },
    {
      id: guid(),
      start: now.setHours(17, 0, 0, 0),
      end: now.setHours(18, 0, 0, 0),
      title: 'Event 11',
      resource: 'v6',
      tripNo: 'T0012749',
      actionCode: HOOKON,
      city: 'Ghent',
      shortCity:'GHE',
      addresscode: 'ADR-0008268',
      addressname: 'Address 8',
      address: 'Street 16',
      postCode: '7084',
      startingDate: 1714608000000,
      startingTime: '08:00:00',
      endingTime: '01:00'
    },
    {
      id: guid(),
      start: now.setHours(20, 0, 0, 0),
      end: now.setHours(21, 0, 0, 0),
      title: 'Event 12',
      resource: 'v6',
      tripNo: 'T0012749',
      actionCode: UNLOAD,
      city: 'Ostend',
      shortCity:'OSD',
      addresscode: 'ADR-0005773',
      addressname: 'Address 61',
      address: 'Street 25',
      postCode: '6176',
      startingDate: 1714608000000,
      startingTime: '13:00:00',
      endingTime: '02:00'
    },
    {
      id: guid(),
      start: now.setHours(4, 0, 0, 0),
      end: now.setHours(5, 0, 0, 0),
      title: 'Event 13',
      resource: 'v7',
      tripNo: 'T001275',
      actionCode: PICKUP,
      city: 'Charleroi',
      shortCity:'CRL',
      addresscode: 'ADR-0008766',
      addressname: 'Address 58',
      address: 'Street 95',
      postCode: '8355',
      startingDate: 1714608000000,
      startingTime: '08:00:00',
      endingTime: '01:00'
    },
    {
      id: guid(),
      start: now.setHours(6, 0, 0, 0),
      end: now.setHours(7, 0, 0, 0),
      title: 'Event 14',
      resource: 'v7',
      tripNo: 'T001275',
      actionCode: LOAD,
      city: 'Charleroi',
      shortCity:'CRL',
      addresscode: 'ADR-00039',
      addressname: 'Address 12',
      address: 'Street 83',
      postCode: '7260',
      startingDate: 1714608000000,
      startingTime: '13:00:00',
      endingTime: '02:00'
    },
    {
      id: guid(),
      start: now.setHours(8, 0, 0, 0),
      end: now.setHours(9, 0, 0, 0),
      title: 'Event 14',
      resource: 'v7',
      tripNo: 'T001275',
      actionCode: DEPOSIT,
      city: 'Brussels',
      shortCity:'BRU',
      addresscode: 'ADR-00039',
      addressname: 'Address 12',
      address: 'Street 83',
      postCode: '7260',
      startingDate: 1714608000000,
      startingTime: '13:00:00',
      endingTime: '02:00'
    },{
      id: guid(),
      start: now.setHours(4, 0, 0, 0),
      end: now.setHours(5, 0, 0, 0),
      title: 'Event 13',
      resource: 't1',
      tripNo: 'T0011759',
      actionCode: PICKUP,
      city: 'Charleroi',
      shortCity:'CRL',
      addresscode: 'ADR-0008766',
      addressname: 'Address 58',
      address: 'Street 95',
      postCode: '8355',
      startingDate: 1714608000000,
      startingTime: '08:00:00',
      endingTime: '01:00'
    },
    {
      id: guid(),
      start: now.setHours(6, 0, 0, 0),
      end: now.setHours(7, 0, 0, 0),
      title: 'Event 14',
      resource: 't1',
      tripNo: 'T0011759',
      actionCode: LOAD,
      city: 'Charleroi',
      shortCity:'CRL',
      addresscode: 'ADR-00039',
      addressname: 'Address 12',
      address: 'Street 83',
      postCode: '7260',
      startingDate: 1714608000000,
      startingTime: '13:00:00',
      endingTime: '02:00'
    },
    {
      id: guid(),
      start: now.setHours(8, 0, 0, 0),
      end: now.setHours(9, 0, 0, 0),
      title: 'Event 14',
      resource: 't1',
      tripNo: 'T0011759',
      actionCode: DEPOSIT,
      city: 'Brussels',
      shortCity:'BRU',
      addresscode: 'ADR-00039',
      addressname: 'Address 12',
      address: 'Street 83',
      postCode: '7260',
      startingDate: 1714608000000,
      startingTime: '13:00:00',
      endingTime: '02:00'
    },
    {
      id: guid(),
      start: now.setHours(2, 0, 0, 0),
      end: now.setHours(3, 0, 0, 0),
      title: 'Event 15',
      resource: 'v8',
      tripNo: 'T001276',
      actionCode: PICKUP,
      city: 'Groningen',
      shortCity:'GRO',
      addresscode: 'ADR-0003712',
      addressname: 'Address 20',
      address: 'Street 13',
      postCode: '7683',
      startingDate: 1714608000000,
      startingTime: '08:00:00',
      endingTime: '01:00'
    },
    {
      id: guid(),
      start: now.setHours(5, 0, 0, 0),
      end: now.setHours(6, 0, 0, 0),
      title: 'Event 16',
      resource: 'v8',
      tripNo: 'T001276',
      actionCode: UNLOAD,
      city: 'Luik',
      shortCity:'LUK',
      addresscode: 'ADR-0004236',
      addressname: 'Address 8',
      address: 'Street 42',
      postCode: '3160',
      startingDate: 1714608000000,
      startingTime: '13:00:00',
      endingTime: '02:00'
    },
    {
      id: guid(),
      start: now.setHours(8, 0, 0, 0),
      end: now.setHours(9, 0, 0, 0),
      title: 'Event 16',
      resource: 'v8',
      tripNo: 'T001276',
      actionCode: DEPOSIT,
      city: 'Charleroi',
      shortCity:'CRL',
      addresscode: 'ADR-0004236',
      addressname: 'Address 8',
      address: 'Street 42',
      postCode: '3160',
      startingDate: 1714608000000,
      startingTime: '13:00:00',
      endingTime: '02:00'
    },
    {
      id: guid(),
      start: now.setHours(15, 0, 0, 0),
      end: now.setHours(16, 0, 0, 0),
      title: 'Event 15',
      resource: 't2',
      tripNo: 'T0012961',
      actionCode: PICKUP,
      city: 'Groningen',
      shortCity:'GRO',
      addresscode: 'ADR-0003712',
      addressname: 'Address 20',
      address: 'Street 13',
      postCode: '7683',
      startingDate: 1714608000000,
      startingTime: '08:00:00',
      endingTime: '01:00'
    },
    {
      id: guid(),
      start: now.setHours(18, 0, 0, 0),
      end: now.setHours(19, 0, 0, 0),
      title: 'Event 16',
      resource: 't2',
      tripNo: 'T0012961',
      actionCode: UNLOAD,
      city: 'Luik',
      shortCity:'LUK',
      addresscode: 'ADR-0004236',
      addressname: 'Address 8',
      address: 'Street 42',
      postCode: '3160',
      startingDate: 1714608000000,
      startingTime: '13:00:00',
      endingTime: '02:00'
    },
    {
      id: guid(),
      start: now.setHours(22, 0, 0, 0),
      end: now.setHours(23, 0, 0, 0),
      title: 'Event 16',
      resource: 't2',
      tripNo: 'T0012961',
      actionCode: DEPOSIT,
      city: 'Charleroi',
      shortCity:'CRL',
      addresscode: 'ADR-0004236',
      addressname: 'Address 8',
      address: 'Street 42',
      postCode: '3160',
      startingDate: 1714608000000,
      startingTime: '13:00:00',
      endingTime: '02:00'
    },
    {
      id: guid(),
      start: now.setHours(14, 0, 0, 0),
      end: now.setHours(15, 0, 0, 0),
      title: 'Event 17',
      resource: 's3',
      tripNo: 'T0012971',
      actionCode: CLEANING,
      city: 'Antwerp',
      shortCity:"ANR",
      addresscode: 'ADR-0004656',
      addressname: 'Address 57',
      address: 'Street 58',
      postCode: '9608',
      startingDate: 1714608000000,
      startingTime: '08:00:00',
      endingTime: '01:00'
    },
    {
      id: guid(),
      start: now.setHours(17, 0, 0, 0),
      end: now.setHours(18, 0, 0, 0),
      title: 'Event 17',
      resource: 's3',
      tripNo: 'T0012971',
      actionCode: LOAD,
      city: 'Antwerp',
      shortCity:"ANR",
      addresscode: 'ADR-0004656',
      addressname: 'Address 57',
      address: 'Street 58',
      postCode: '9608',
      startingDate: 1714608000000,
      startingTime: '08:00:00',
      endingTime: '01:00'
    },
    {
      id: guid(),
      start: now.setHours(20, 0, 0, 0),
      end: now.setHours(21, 0, 0, 0),
      title: 'Event 18',
      resource: 's3',
      tripNo: 'T0012971',
      actionCode: UNLOAD,
      city: 'Breda',
      shortCity:'BRD',
      addresscode: 'ADR-0003221',
      addressname: 'Address 19',
      address: 'Street 23',
      postCode: '7697',
      startingDate: 1714608000000,
      startingTime: '13:00:00',
      endingTime: '02:00'
    },
    {
      id: guid(),
      start: now.setHours(8, 0, 0, 0),
      end: now.setHours(9, 0, 0, 0),
      title: 'Event 17',
      resource: 'v9',
      tripNo: 'T001277',
      actionCode: CLEANING,
      city: 'Antwerp',
      shortCity:"ANR",
      addresscode: 'ADR-0004656',
      addressname: 'Address 57',
      address: 'Street 58',
      postCode: '9608',
      startingDate: 1714608000000,
      startingTime: '08:00:00',
      endingTime: '01:00'
    },
    {
      id: guid(),
      start: now.setHours(10, 0, 0, 0),
      end: now.setHours(11, 0, 0, 0),
      title: 'Event 17',
      resource: 'v9',
      tripNo: 'T001277',
      actionCode: LOAD,
      city: 'Antwerp',
      shortCity:"ANR",
      addresscode: 'ADR-0004656',
      addressname: 'Address 57',
      address: 'Street 58',
      postCode: '9608',
      startingDate: 1714608000000,
      startingTime: '08:00:00',
      endingTime: '01:00'
    },
    {
      id: guid(),
      start: now.setHours(12, 0, 0, 0),
      end: now.setHours(13, 0, 0, 0),
      title: 'Event 18',
      resource: 'v9',
      tripNo: 'T001277',
      actionCode: UNLOAD,
      city: 'Breda',
      shortCity:'BRD',
      addresscode: 'ADR-0003221',
      addressname: 'Address 19',
      address: 'Street 23',
      postCode: '7697',
      startingDate: 1714608000000,
      startingTime: '13:00:00',
      endingTime: '02:00'
    },
    {
      id: guid(),
      start: now.setHours(6, 0, 0, 0),
      end: now.setHours(7, 0, 0, 0),
      title: 'Event 19',
      resource: 'v10',
      tripNo: 'T001278',
      actionCode: 'LOAD',
      city: 'Eindhoven',
      shortCity:"EDV",
      addresscode: 'ADR-0009372',
      addressname: 'Address 1',
      address: 'Street 36',
      postCode: '3583',
      startingDate: 1714608000000,
      startingTime: '08:00:00',
      endingTime: '01:00'
    },
    {
      id: guid(),
      start: now.setHours(11, 0, 0, 0),
      end: now.setHours(12, 0, 0, 0),
      title: 'Event 20',
      resource: 'v10',
      tripNo: 'T001278',
      actionCode: 'UNLOAD',
      city: 'Charleroi',
      shortCity:'CRL',
      addresscode: 'ADR-0008634',
      addressname: 'Address 87',
      address: 'Street 31',
      postCode: '4672',
      startingDate: 1714608000000,
      startingTime: '13:00:00',
      endingTime: '02:00'
    },
    {
      id: guid(),
      start: now.setHours(2, 0, 0, 0),
      end: now.setHours(3, 0, 0, 0),
      title: 'Event 21',
      resource: 'v11',
      tripNo: 'T001279',
      actionCode: 'COUPLE',
      city: 'Charleroi',
      shortCity:'CRL',
      addresscode: 'ADR-00068',
      addressname: 'Address 51',
      address: 'Street 51',
      postCode: '6374',
      startingDate: 1714608000000,
      startingTime: '08:00:00',
      endingTime: '01:00'
    },
    {
      id: guid(),
      start: now.setHours(5, 0, 0, 0),
      end: now.setHours(6, 0, 0, 0),
      title: 'Event 21',
      resource: 'v11',
      tripNo: 'T001279',
      actionCode: 'LOAD',
      city: 'Namur',
      shortCity:'WNA',
      addresscode: 'ADR-00068',
      addressname: 'Address 51',
      address: 'Street 51',
      postCode: '6374',
      startingDate: 1714608000000,
      startingTime: '08:00:00',
      endingTime: '01:00'
    },
    {
      id: guid(),
      start: now.setHours(7, 0, 0, 0),
      end: now.setHours(8, 0, 0, 0),
      title: 'Event 21',
      resource: 'v11',
      tripNo: 'T001279',
      actionCode: 'BREAK',
      city: 'Namur',
      shortCity:'WNA',
      addresscode: 'ADR-00068',
      addressname: 'Address 51',
      address: 'Street 51',
      postCode: '6374',
      startingDate: 1714608000000,
      startingTime: '08:00:00',
      endingTime: '01:00'
    },
    {
      id: guid(),
      start: now.setHours(10, 30, 0, 0),
      end: now.setHours(11, 30, 0, 0),
      title: 'Event 22',
      resource: 'v11',
      tripNo: 'T001279',
      actionCode: 'UNLOAD',
      city: 'Antwerp',
      shortCity:"ANR",
      addresscode: 'ADR-0002348',
      addressname: 'Address 18',
      address: 'Street 30',
      postCode: '7669',
      startingDate: 1714608000000,
      startingTime: '13:00:00',
      endingTime: '02:00'
    },
    {
      id: guid(),
      start: now.setHours(13, 0, 0, 0),
      end: now.setHours(14, 0, 0, 0),
      title: 'Event 22',
      resource: 'v11',
      tripNo: 'T001279',
      actionCode: UNCOUPLE,
      city: 'Antwerp',
      shortCity:"ANR",
      addresscode: 'ADR-0002348',
      addressname: 'Address 18',
      address: 'Street 30',
      postCode: '7669',
      startingDate: 1714608000000,
      startingTime: '13:00:00',
      endingTime: '02:00'
    },
    {
      id: guid(),
      start: now.setHours(6, 0, 0, 0),
      end: now.setHours(7, 0, 0, 0),
      title: 'Event 23',
      resource: 'v12',
      tripNo: 'T001280',
      actionCode: 'LOAD',
      city: 'Namur',
      shortCity:'WNA',
      addresscode: 'ADR-0009425',
      addressname: 'Address 39',
      address: 'Street 70',
      postCode: '890',
      startingDate: 1714608000000,
      startingTime: '08:00:00',
      endingTime: '01:00'
    },
    {
      id: guid(),
      start: now.setHours(11, 0, 0, 0),
      end: now.setHours(12, 0, 0, 0),
      title: 'Event 24',
      resource: 'v12',
      tripNo: 'T001280',
      actionCode: 'UNLOAD',
      city: 'Ostend',
      shortCity:'OSD',
      addresscode: 'ADR-0007988',
      addressname: 'Address 19',
      address: 'Street 98',
      postCode: '1875',
      startingDate: 1714608000000,
      startingTime: '13:00:00',
      endingTime: '02:00'
    },
    {
      id: guid(),
      start: now.setHours(10, 0, 0, 0),
      end: now.setHours(11, 0, 0, 0),
      title: 'Event 25',
      resource: 'v13',
      tripNo: 'T001281',
      actionCode: 'LOAD',
      city: 'Brussels',
      shortCity:'BRU',
      addresscode: 'ADR-0009093',
      addressname: 'Address 83',
      address: 'Street 75',
      postCode: '1286',
      startingDate: 1714608000000,
      startingTime: '08:00:00',
      endingTime: '01:00'
    },
    {
      id: guid(),
      start: now.setHours(14, 0, 0, 0),
      end: now.setHours(15, 0, 0, 0),
      title: 'Event 26',
      resource: 'v13',
      tripNo: 'T001281',
      actionCode: 'UNLOAD',
      city: 'Namur',
      shortCity:'WNA',
      addresscode: 'ADR-000463',
      addressname: 'Address 10',
      address: 'Street 45',
      postCode: '4235',
      startingDate: 1714608000000,
      startingTime: '13:00:00',
      endingTime: '02:00'
    },
    {
      id: guid(),
      start: now.setHours(11, 0, 0, 0),
      end: now.setHours(12, 0, 0, 0),
      title: 'Event 27',
      resource: 'v14',
      tripNo: 'T001282',
      actionCode: 'LOAD',
      city: 'Breda',
      shortCity:'BRD',
      addresscode: 'ADR-0001226',
      addressname: 'Address 19',
      address: 'Street 59',
      postCode: '4119',
      startingDate: 1714608000000,
      startingTime: '08:00:00',
      endingTime: '01:00'
    },
    {
      id: guid(),
      start: now.setHours(16, 0, 0, 0),
      end: now.setHours(17, 0, 0, 0),
      title: 'Event 28',
      resource: 'v14',
      tripNo: 'T001282',
      actionCode: 'UNLOAD',
      city: 'Brussels',
      shortCity:'BRU',
      addresscode: 'ADR-0008186',
      addressname: 'Address 47',
      address: 'Street 54',
      postCode: '5144',
      startingDate: 1714608000000,
      startingTime: '13:00:00',
      endingTime: '02:00'
    },
    {
      id: guid(),
      start: now.setHours(2, 0, 0, 0),
      end: now.setHours(3, 0, 0, 0),
      title: 'Event 29',
      resource: 'v15',
      tripNo: 'T001283',
      actionCode: 'LOAD',
      city: 'Almere',
      shortCity:"ALR",
      addresscode: 'ADR-0001716',
      addressname: 'Address 10',
      address: 'Street 51',
      postCode: '2326',
      startingDate: 1714608000000,
      startingTime: '08:00:00',
      endingTime: '01:00'
    },
    {
      id: guid(),
      start: now.setHours(4, 0, 0, 0),
      end: now.setHours(5, 0, 0, 0),
      title: 'Event 30',
      resource: 'v15',
      tripNo: 'T001283',
      actionCode: 'UNLOAD',
      city: 'Nijmegen',
      shortCity:'NIJ',
      addresscode: 'ADR-000612',
      addressname: 'Address 45',
      address: 'Street 63',
      postCode: '1275',
      startingDate: 1714608000000,
      startingTime: '13:00:00',
      endingTime: '02:00'
    },
    {
      id: guid(),
      start: now.setHours(12, 0, 0, 0),
      end: now.setHours(13, 0, 0, 0),
      title: 'Event 31',
      resource: 's1',
      tripNo: 'T001284',
      actionCode: 'LOAD',
      city: 'Brussels',
      shortCity:'BRU',
      addresscode: 'ADR-0002798',
      addressname: 'Address 44',
      address: 'Street 88',
      postCode: '1300',
      startingDate: 1714608000000,
      startingTime: '08:00:00',
      endingTime: '01:00'
    },
    {
      id: guid(),
      start: now.setHours(16, 0, 0, 0),
      end: now.setHours(17, 0, 0, 0),
      title: 'Event 32',
      resource: 's1',
      tripNo: 'T001284',
      actionCode: 'UNLOAD',
      city: 'Almere',
      shortCity:"ALR",
      addresscode: 'ADR-0007650',
      addressname: 'Address 55',
      address: 'Street 81',
      postCode: '2541',
      startingDate: 1714608000000,
      startingTime: '13:00:00',
      endingTime: '02:00'
    },
    {
      id: guid(),
      start: now.setHours(9, 0, 0, 0),
      end: now.setHours(10, 0, 0, 0),
      title: 'Event 33',
      resource: 's2',
      tripNo: 'T001285',
      actionCode: 'LOAD',
      city: 'Antwerp',
      shortCity:"ANR",
      addresscode: 'ADR-0007157',
      addressname: 'Address 11',
      address: 'Street 4',
      postCode: '9727',
      startingDate: 1714608000000,
      startingTime: '08:00:00',
      endingTime: '01:00'
    },
    {
      id: guid(),
      start: now.setHours(12, 30, 0, 0),
      end: now.setHours(14, 0, 0, 0),
      title: 'Event 34',
      resource: 's2',
      tripNo: 'T001285',
      actionCode: 'UNLOAD',
      city: 'Charleroi',
      shortCity:'CRL',
      addresscode: 'ADR-0001468',
      addressname: 'Address 37',
      address: 'Street 52',
      postCode: '577',
      startingDate: 1714608000000,
      startingTime: '13:00:00',
      endingTime: '02:00'
    },
    {
      id: guid(),
      start: now.setHours(5, 0, 0, 0),
      end: now.setHours(6, 0, 0, 0),
      title: 'Event 35',
      resource: 's3',
      tripNo: 'T001286',
      actionCode: 'LOAD',
      city: 'Nijmegen',
      shortCity:'NIJ',
      addresscode: 'ADR-000989',
      addressname: 'Address 0',
      address: 'Street 93',
      postCode: '7193',
      startingDate: 1714608000000,
      startingTime: '08:00:00',
      endingTime: '01:00'
    },
    {
      id: guid(),
      start: now.setHours(9, 0, 0, 0),
      end: now.setHours(10, 0, 0, 0),
      title: 'Event 36',
      resource: 's3',
      tripNo: 'T001286',
      actionCode: 'UNLOAD',
      city: 'Charleroi',
      shortCity:'CRL',
      addresscode: 'ADR-0005489',
      addressname: 'Address 85',
      address: 'Street 2',
      postCode: '3597',
      startingDate: 1714608000000,
      startingTime: '13:00:00',
      endingTime: '02:00'
    },
    {
      id: guid(),
      start: now.setHours(9, 0, 0, 0),
      end: now.setHours(10, 0, 0, 0),
      title: 'Event 37',
      resource: 's4',
      tripNo: 'T001287',
      actionCode: 'LOAD',
      city: 'Ostend',
      shortCity:'OSD',
      addresscode: 'ADR-0003674',
      addressname: 'Address 59',
      address: 'Street 65',
      postCode: '2478',
      startingDate: 1714608000000,
      startingTime: '08:00:00',
      endingTime: '01:00'
    },
    {
      id: guid(),
      start: now.setHours(13, 0, 0, 0),
      end: now.setHours(14, 0, 0, 0),
      title: 'Event 38',
      resource: 's4',
      tripNo: 'T001287',
      actionCode: 'UNLOAD',
      city: 'Nijmegen',
      shortCity:'NIJ',
      addresscode: 'ADR-0008583',
      addressname: 'Address 78',
      address: 'Street 20',
      postCode: '545',
      startingDate: 1714608000000,
      startingTime: '13:00:00',
      endingTime: '02:00'
    },
    {
      id: guid(),
      start: now.setHours(13, 0, 0, 0),
      end: now.setHours(14, 0, 0, 0),
      title: 'Event 39',
      resource: 's5',
      tripNo: 'T001288',
      actionCode: 'LOAD',
      city: 'Groningen',
      shortCity:'GRO',
      addresscode: 'ADR-0001554',
      addressname: 'Address 45',
      address: 'Street 65',
      postCode: '777',
      startingDate: 1714608000000,
      startingTime: '08:00:00',
      endingTime: '01:00'
    },
    {
      id: guid(),
      start: now.setHours(18, 0, 0, 0),
      end: now.setHours(19, 0, 0, 0),
      title: 'Event 40',
      resource: 's5',
      tripNo: 'T001288',
      actionCode: 'UNLOAD',
      city: 'Groningen',
      shortCity:'GRO',
      addresscode: 'ADR-0008709',
      addressname: 'Address 97',
      address: 'Street 41',
      postCode: '3114',
      startingDate: 1714608000000,
      startingTime: '13:00:00',
      endingTime: '02:00'
    },
    {
      id: guid(),
      start: now.setHours(10, 0, 0, 0),
      end: now.setHours(11, 0, 0, 0),
      title: 'Event 41',
      resource: 's6',
      tripNo: 'T001289',
      actionCode: 'LOAD',
      city: 'Charleroi',
      shortCity:'CRL',
      addresscode: 'ADR-0005235',
      addressname: 'Address 90',
      address: 'Street 63',
      postCode: '4845',
      startingDate: 1714608000000,
      startingTime: '08:00:00',
      endingTime: '01:00'
    },
    {
      id: guid(),
      start: now.setHours(16, 0, 0, 0),
      end: now.setHours(17, 0, 0, 0),
      title: 'Event 42',
      resource: 's6',
      tripNo: 'T001289',
      actionCode: 'UNLOAD',
      city: 'Ostend',
      shortCity:'OSD',
      addresscode: 'ADR-0007233',
      addressname: 'Address 54',
      address: 'Street 4',
      postCode: '7920',
      startingDate: 1714608000000,
      startingTime: '13:00:00',
      endingTime: '02:00'
    },
    {
      id: guid(),
      start: now.setHours(6, 0, 0, 0),
      end: now.setHours(7, 0, 0, 0),
      title: 'Event 43',
      resource: 's7',
      tripNo: 'T001290',
      actionCode: 'LOAD',
      city: 'Nijmegen',
      shortCity:'NIJ',
      addresscode: 'ADR-0001228',
      addressname: 'Address 52',
      address: 'Street 84',
      postCode: '560',
      startingDate: 1714608000000,
      startingTime: '08:00:00',
      endingTime: '01:00'
    },
    {
      id: guid(),
      start: now.setHours(13, 0, 0, 0),
      end: now.setHours(14, 0, 0, 0),
      title: 'Event 44',
      resource: 's7',
      tripNo: 'T001290',
      actionCode: 'UNLOAD',
      city: 'Charleroi',
      shortCity:'CRL',
      addresscode: 'ADR-0005016',
      addressname: 'Address 60',
      address: 'Street 3',
      postCode: '5462',
      startingDate: 1714608000000,
      startingTime: '13:00:00',
      endingTime: '02:00'
    },
    {
      id: guid(),
      start: now.setHours(15, 0, 0, 0),
      end: now.setHours(16, 0, 0, 0),
      title: 'Event 45',
      resource: 's8',
      tripNo: 'T001291',
      actionCode: 'LOAD',
      city: 'Groningen',
      shortCity:'GRO',
      addresscode: 'ADR-0006664',
      addressname: 'Address 31',
      address: 'Street 78',
      postCode: '1023',
      startingDate: 1714608000000,
      startingTime: '08:00:00',
      endingTime: '01:00'
    },
    {
      id: guid(),
      start: tommorow.setHours(3, 0, 0, 0),
      end: tommorow.setHours(4, 0, 0, 0),
      title: 'Event 46',
      resource: 's8',
      tripNo: 'T001291',
      actionCode: 'UNLOAD',
      city: 'Almere',
      shortCity:"ALR",
      addresscode: 'ADR-0004475',
      addressname: 'Address 3',
      address: 'Street 81',
      postCode: '4924',
      startingDate: 1714608000000,
      startingTime: '13:00:00',
      endingTime: '02:00'
    },
    {
      id: guid(),
      start: now.setHours(10, 0, 0, 0),
      end: now.setHours(11, 0, 0, 0),
      title: 'Event 47',
      resource: 's9',
      tripNo: 'T001292',
      actionCode: 'LOAD',
      city: 'Almere',
      shortCity:"ALR",
      addresscode: 'ADR-0006954',
      addressname: 'Address 16',
      address: 'Street 40',
      postCode: '8494',
      startingDate: 1714608000000,
      startingTime: '08:00:00',
      endingTime: '01:00'
    },
    {
      id: guid(),
      start: now.setHours(14, 0, 0, 0),
      end: now.setHours(15, 0, 0, 0),
      title: 'Event 48',
      resource: 's9',
      tripNo: 'T001292',
      actionCode: 'UNLOAD',
      city: 'Antwerp',
      shortCity:"ANR",
      addresscode: 'ADR-0006963',
      addressname: 'Address 59',
      address: 'Street 55',
      postCode: '7494',
      startingDate: 1714608000000,
      startingTime: '13:00:00',
      endingTime: '02:00'
    },
    {
      id: guid(),
      start: now.setHours(5, 0, 0, 0),
      end: now.setHours(6, 0, 0, 0),
      title: 'Event 49',
      resource: 's10',
      tripNo: 'T001293',
      actionCode: 'LOAD',
      city: 'Eindhoven',
      shortCity:"EDV",
      addresscode: 'ADR-0009585',
      addressname: 'Address 78',
      address: 'Street 29',
      postCode: '9319',
      startingDate: 1714608000000,
      startingTime: '08:00:00',
      endingTime: '01:00'
    },
    {
      id: guid(),
      start: now.setHours(10, 0, 0, 0),
      end: now.setHours(11, 0, 0, 0),
      title: 'Event 50',
      resource: 's10',
      tripNo: 'T001293',
      actionCode: 'UNLOAD',
      city: 'Nijmegen',
      shortCity:'NIJ',
      addresscode: 'ADR-0003902',
      addressname: 'Address 41',
      address: 'Street 73',
      postCode: '5958',
      startingDate: 1714608000000,
      startingTime: '13:00:00',
      endingTime: '02:00'
    },
    {
      id: guid(),
      start: now.setHours(9, 0, 0, 0),
      end: now.setHours(10, 0, 0, 0),
      title: 'Event 51',
      resource: 's11',
      tripNo: 'T001294',
      actionCode: 'LOAD',
      city: 'Groningen',
      shortCity:'GRO',
      addresscode: 'ADR-0006032',
      addressname: 'Address 22',
      address: 'Street 30',
      postCode: '4207',
      startingDate: 1714608000000,
      startingTime: '08:00:00',
      endingTime: '01:00'
    },
    {
      id: guid(),
      start: now.setHours(15, 0, 0, 0),
      end: now.setHours(16, 0, 0, 0),
      title: 'Event 52',
      resource: 's11',
      tripNo: 'T001294',
      actionCode: 'UNLOAD',
      city: 'Antwerp',
      shortCity:"ANR",
      addresscode: 'ADR-0009067',
      addressname: 'Address 96',
      address: 'Street 27',
      postCode: '8256',
      startingDate: 1714608000000,
      startingTime: '13:00:00',
      endingTime: '02:00'
    },
    {
      id: guid(),
      start: now.setHours(7, 0, 0, 0),
      end: now.setHours(8, 0, 0, 0),
      title: 'Event 53',
      resource: 's12',
      tripNo: 'T001295',
      actionCode: 'LOAD',
      city: 'Nijmegen',
      shortCity:'NIJ',
      addresscode: 'ADR-0005780',
      addressname: 'Address 35',
      address: 'Street 38',
      postCode: '1477',
      startingDate: 1714608000000,
      startingTime: '08:00:00',
      endingTime: '01:00'
    },
    {
      id: guid(),
      start: now.setHours(11, 0, 0, 0),
      end: now.setHours(12, 0, 0, 0),
      title: 'Event 54',
      resource: 's12',
      tripNo: 'T001295',
      actionCode: 'UNLOAD',
      city: 'Almere',
      shortCity:"ALR",
      addresscode: 'ADR-0005197',
      addressname: 'Address 84',
      address: 'Street 6',
      postCode: '9560',
      startingDate: 1714608000000,
      startingTime: '13:00:00',
      endingTime: '02:00'
    },
    {
      id: guid(),
      start: now.setHours(12, 0, 0, 0),
      end: now.setHours(13, 0, 0, 0),
      title: 'Event 55',
      resource: 's13',
      tripNo: 'T00129612',
      actionCode: 'LOAD',
      city: 'Eindhoven',
      shortCity:"EDV",
      addresscode: 'ADR-0008128',
      addressname: 'Address 67',
      address: 'Street 80',
      postCode: '9172',
      startingDate: 1714608000000,
      startingTime: '08:00:00',
      endingTime: '01:00'
    },
    {
      id: guid(),
      start: now.setHours(18, 0, 0, 0),
      end: now.setHours(19, 0, 0, 0),
      title: 'Event 56',
      resource: 's13',
      tripNo: 'T00129612',
      actionCode: 'UNLOAD',
      city: 'Ostend',
      shortCity:'OSD',
      addresscode: 'ADR-000669',
      addressname: 'Address 62',
      address: 'Street 25',
      postCode: '4558',
      startingDate: 1714608000000,
      startingTime: '13:00:00',
      endingTime: '02:00'
    },
    {
      id: guid(),
      start: now.setHours(13, 0, 0, 0),
      end: now.setHours(14, 0, 0, 0),
      title: 'Event 57',
      resource: 's14',
      tripNo: 'T001297',
      actionCode: 'LOAD',
      city: 'Namur',
      shortCity:'WNA',
      addresscode: 'ADR-0009408',
      addressname: 'Address 61',
      address: 'Street 16',
      postCode: '5933',
      startingDate: 1714608000000,
      startingTime: '08:00:00',
      endingTime: '01:00'
    },
    {
      id: guid(),
      start: now.setHours(20, 0, 0, 0),
      end: now.setHours(21, 0, 0, 0),
      title: 'Event 58',
      resource: 's14',
      tripNo: 'T001297',
      actionCode: 'UNLOAD',
      city: 'Brussels',
      shortCity:'BRU',
      addresscode: 'ADR-0002373',
      addressname: 'Address 63',
      address: 'Street 9',
      postCode: '7683',
      startingDate: 1714608000000,
      startingTime: '13:00:00',
      endingTime: '02:00'
    },
    {
      id: guid(),
      start: now.setHours(11, 0, 0, 0),
      end: now.setHours(12, 0, 0, 0),
      title: 'Event 59',
      resource: 's15',
      tripNo: 'T001298',
      actionCode: 'LOAD',
      city: 'Groningen',
      shortCity:'GRO',
      addresscode: 'ADR-0005168',
      addressname: 'Address 48',
      address: 'Street 56',
      postCode: '7248',
      startingDate: 1714608000000,
      startingTime: '08:00:00',
      endingTime: '01:00'
    },
    {
      id: guid(),
      start: now.setHours(19, 0, 0, 0),
      end: now.setHours(20, 0, 0, 0),
      title: 'Event 60',
      resource: 's15',
      tripNo: 'T001298',
      actionCode: 'UNLOAD',
      city: 'Groningen',
      shortCity:'GRO',
      addresscode: 'ADR-0003258',
      addressname: 'Address 46',
      address: 'Street 22',
      postCode: '8415',
      startingDate: 1714608000000,
      startingTime: '13:00:00',
      endingTime: '02:00'
    },
    {
      id: guid(),
      start: now.setHours(10, 0, 0, 0),
      end: now.setHours(11, 0, 0, 0),
      title: 'Event 61',
      resource: 't1',
      tripNo: 'T001299',
      actionCode: 'LOAD',
      city: 'Groningen',
      shortCity:'GRO',
      addresscode: 'ADR-0001824',
      addressname: 'Address 34',
      address: 'Street 55',
      postCode: '4095',
      startingDate: 1714608000000,
      startingTime: '08:00:00',
      endingTime: '01:00'
    },
    {
      id: guid(),
      start: now.setHours(19, 0, 0, 0),
      end: now.setHours(20, 0, 0, 0),
      title: 'Event 62',
      resource: 't1',
      tripNo: 'T001299',
      actionCode: 'UNLOAD',
      city: 'Namur',
      shortCity:'WNA',
      addresscode: 'ADR-000497',
      addressname: 'Address 66',
      address: 'Street 83',
      postCode: '8322',
      startingDate: 1714608000000,
      startingTime: '13:00:00',
      endingTime: '02:00'
    },
    {
      id: guid(),
      start: now.setHours(10, 0, 0, 0),
      end: now.setHours(11, 0, 0, 0),
      title: 'Event 63',
      resource: 't8',
      tripNo: 'T001300',
      actionCode: 'LOAD',
      city: 'Ostend',
      shortCity:'OSD',
      addresscode: 'ADR-0005232',
      addressname: 'Address 9',
      address: 'Street 12',
      postCode: '8461',
      startingDate: 1714608000000,
      startingTime: '08:00:00',
      endingTime: '01:00'
    },
    {
      id: guid(),
      start: now.setHours(16, 0, 0, 0),
      end: now.setHours(17, 0, 0, 0),
      title: 'Event 64',
      resource: 't8',
      tripNo: 'T001300',
      actionCode: 'UNLOAD',
      city: 'Brussels',
      shortCity:'BRU',
      addresscode: 'ADR-0007078',
      addressname: 'Address 67',
      address: 'Street 16',
      postCode: '4683',
      startingDate: 1714608000000,
      startingTime: '13:00:00',
      endingTime: '02:00'
    },
    {
      id: guid(),
      start: now.setHours(9, 0, 0, 0),
      end: now.setHours(10, 0, 0, 0),
      title: 'Event 65',
      resource: 't3',
      tripNo: 'T001301',
      actionCode: 'LOAD',
      city: 'Almere',
      shortCity:"ALR",
      addresscode: 'ADR-0007266',
      addressname: 'Address 72',
      address: 'Street 79',
      postCode: '9423',
      startingDate: 1714608000000,
      startingTime: '08:00:00',
      endingTime: '01:00'
    },
    {
      id: guid(),
      start: now.setHours(15, 0, 0, 0),
      end: now.setHours(16, 0, 0, 0),
      title: 'Event 66',
      resource: 't3',
      tripNo: 'T001301',
      actionCode: 'UNLOAD',
      city: 'Groningen',
      shortCity:'GRO',
      addresscode: 'ADR-000891',
      addressname: 'Address 11',
      address: 'Street 57',
      postCode: '5082',
      startingDate: 1714608000000,
      startingTime: '13:00:00',
      endingTime: '02:00'
    },
    {
      id: guid(),
      start: now.setHours(8, 0, 0, 0),
      end: now.setHours(9, 0, 0, 0),
      title: 'Event 67',
      resource: 't4',
      tripNo: 'T001302',
      actionCode: 'LOAD',
      city: 'Groningen',
      shortCity:'GRO',
      addresscode: 'ADR-0008397',
      addressname: 'Address 56',
      address: 'Street 22',
      postCode: '9633',
      startingDate: 1714608000000,
      startingTime: '08:00:00',
      endingTime: '01:00'
    }, {
      id: guid(),
      start: now.setHours(12, 0, 0, 0),
      end: now.setHours(13, 0, 0, 0),
      title: 'Event 745',
      resource: 't4',
      tripNo: 'T001302',
      actionCode: 'UNLOAD',
      city: 'Groningen',
      shortCity:'GRO',
      addresscode: 'ADR-0008397',
      addressname: 'Address 56',
      address: 'Street 22',
      postCode: '9633',
      startingDate: 1714608000000,
      startingTime: '08:00:00',
      endingTime: '01:00'
    },
    {
      id: guid(),
      start: now.setHours(18, 0, 0, 0),
      end: now.setHours(19, 0, 0, 0),
      title: 'Event 68',
      resource: 't4',
      tripNo: 'T001302',
      actionCode: 'UNLOAD',
      city: 'Brussels',
      shortCity:'BRU',
      addresscode: 'ADR-0003025',
      addressname: 'Address 75',
      address: 'Street 66',
      postCode: '9478',
      startingDate: 1714608000000,
      startingTime: '13:00:00',
      endingTime: '02:00'
    },
    {
      id: guid(),
      start: now.setHours(7, 0, 0, 0),
      end: now.setHours(8, 0, 0, 0),
      title: 'Event 69',
      resource: 't5',
      tripNo: 'T001303',
      actionCode: 'LOAD',
      city: 'Almere',
      shortCity:"ALR",
      addresscode: 'ADR-0004075',
      addressname: 'Address 13',
      address: 'Street 99',
      postCode: '643',
      startingDate: 1714608000000,
      startingTime: '08:00:00',
      endingTime: '01:00'
    },
    {
      id: guid(),
      start: now.setHours(12, 0, 0, 0),
      end: now.setHours(13, 0, 0, 0),
      title: 'Event 70',
      resource: 't5',
      tripNo: 'T001303',
      actionCode: 'UNLOAD',
      city: 'Breda',
      shortCity:'BRD',
      addresscode: 'ADR-0002530',
      addressname: 'Address 80',
      address: 'Street 98',
      postCode: '2019',
      startingDate: 1714608000000,
      startingTime: '13:00:00',
      endingTime: '02:00'
    },
    {
      id: guid(),
      start: now.setHours(2, 0, 0, 0),
      end: now.setHours(3, 0, 0, 0),
      title: 'Event 71',
      resource: 't6',
      tripNo: 'T001304',
      actionCode: 'LOAD',
      city: 'Breda',
      shortCity:'BRD',
      addresscode: 'ADR-0006725',
      addressname: 'Address 96',
      address: 'Street 13',
      postCode: '7237',
      startingDate: 1714608000000,
      startingTime: '08:00:00',
      endingTime: '01:00'
    },
    {
      id: guid(),
      start: now.setHours(10, 0, 0, 0),
      end: now.setHours(11, 0, 0, 0),
      title: 'Event 72',
      resource: 't6',
      tripNo: 'T001304',
      actionCode: 'UNLOAD',
      city: 'Breda',
      shortCity:'BRD',
      addresscode: 'ADR-0006004',
      addressname: 'Address 51',
      address: 'Street 28',
      postCode: '7007',
      startingDate: 1714608000000,
      startingTime: '13:00:00',
      endingTime: '02:00'
    },
    {
      id: guid(),
      start: now.setHours(3, 0, 0, 0),
      end: now.setHours(4, 0, 0, 0),
      title: 'Event 73',
      resource: 't7',
      tripNo: 'T001305',
      actionCode: 'LOAD',
      city: 'Charleroi',
      shortCity:'CRL',
      addresscode: 'ADR-0009127',
      addressname: 'Address 56',
      address: 'Street 46',
      postCode: '154',
      startingDate: 1714608000000,
      startingTime: '08:00:00',
      endingTime: '01:00'
    },
    {
      id: guid(),
      start: now.setHours(10, 0, 0, 0),
      end: now.setHours(11, 0, 0, 0),
      title: 'Event 74',
      resource: 't7',
      tripNo: 'T001305',
      actionCode: 'UNLOAD',
      city: 'Ostend',
      shortCity:'OSD',
      addresscode: 'ADR-0004708',
      addressname: 'Address 41',
      address: 'Street 53',
      postCode: '4786',
      startingDate: 1714608000000,
      startingTime: '13:00:00',
      endingTime: '02:00'
    },
    {
      id: guid(),
      start: now.setHours(2, 0, 0, 0),
      end: now.setHours(3, 0, 0, 0),
      title: 'Event 75',
      resource: 't8',
      tripNo: 'T001306',
      actionCode: 'LOAD',
      city: 'Namur',
      shortCity:'WNA',
      addresscode: 'ADR-000179',
      addressname: 'Address 40',
      address: 'Street 95',
      postCode: '1206',
      startingDate: 1714608000000,
      startingTime: '08:00:00',
      endingTime: '01:00'
    },
    {
      id: guid(),
      start: now.setHours(9, 0, 0, 0),
      end: now.setHours(10, 0, 0, 0),
      title: 'Event 76',
      resource: 't8',
      tripNo: 'T001306',
      actionCode: 'UNLOAD',
      city: 'Ostend',
      shortCity:'OSD',
      addresscode: 'ADR-0004826',
      addressname: 'Address 5',
      address: 'Street 36',
      postCode: '8961',
      startingDate: 1714608000000,
      startingTime: '13:00:00',
      endingTime: '02:00'
    },
    {
      id: guid(),
      start: now.setHours(6, 0, 0, 0),
      end: now.setHours(7, 0, 0, 0),
      title: 'Event 77',
      resource: 't9',
      tripNo: 'T001307',
      actionCode: 'LOAD',
      city: 'Ostend',
      shortCity:'OSD',
      addresscode: 'ADR-0007862',
      addressname: 'Address 25',
      address: 'Street 21',
      postCode: '8284',
      startingDate: 1714608000000,
      startingTime: '08:00:00',
      endingTime: '01:00'
    },
    {
      id: guid(),
      start: now.setHours(12, 0, 0, 0),
      end: now.setHours(13, 0, 0, 0),
      title: 'Event 78',
      resource: 't9',
      tripNo: 'T001307',
      actionCode: 'UNLOAD',
      city: 'Nijmegen',
      shortCity:'NIJ',
      addresscode: 'ADR-0005908',
      addressname: 'Address 30',
      address: 'Street 6',
      postCode: '1492',
      startingDate: 1714608000000,
      startingTime: '13:00:00',
      endingTime: '02:00'
    },
    {
      id: guid(),
      start: now.setHours(2, 0, 0, 0),
      end: now.setHours(3, 0, 0, 0),
      title: 'Event 79',
      resource: 't10',
      tripNo: 'T001308',
      actionCode: 'LOAD',
      city: 'Antwerp',
      shortCity:"ANR",
      addresscode: 'ADR-0006161',
      addressname: 'Address 29',
      address: 'Street 86',
      postCode: '5402',
      startingDate: 1714608000000,
      startingTime: '08:00:00',
      endingTime: '01:00'
    },
    {
      id: guid(),
      start: now.setHours(10, 0, 0, 0),
      end: now.setHours(11, 0, 0, 0),
      title: 'Event 80',
      resource: 't10',
      tripNo: 'T001308',
      actionCode: 'UNLOAD',
      city: 'Namur',
      shortCity:'WNA',
      addresscode: 'ADR-0007524',
      addressname: 'Address 72',
      address: 'Street 98',
      postCode: '6068',
      startingDate: 1714608000000,
      startingTime: '13:00:00',
      endingTime: '02:00'
    }
  ]

  export const msTruckResourceData = [
    {
      id: 'vehicle',
      name: 'Tractors',
      eventCreation: false,
      children: [
        {
          "id": "v1",
          "name": "63-GXD-5",
          "trailerLicencePlate":"OG-80-KL",
          "countryCode":"nl",
          "vehicleBrand": "bmw",
          "capacityInKg": 1000,
          "eventCreation": false,
          "driverName": "Sergio-Perez",
          "imgPath":SergioPerez,
        },
        {
          "id": "v2",
          "name": "89-DKF-5",
          "trailerLicencePlate":"OT-88-KD",
          "countryCode":"nl",
          "vehicleBrand": "volvo",
          "capacityInKg": 800,
          "driverName": "Valtteri-Bottas",
          "imgPath":ValtteriBottas,
        },
        {
          "id": "v3",
          "name": "1-ABC-001",
          "trailerLicencePlate":"Q-AYP-316",
          "countryCode":"be",
          "vehicleBrand": "toyota",
          "capacityInKg": 1000,
          "driverName": "Alex-Albon",
          "imgPath":AlexAlbon,
        },
        {
          "id": "v4",
          "name": "BG 90 920",
          "trailerLicencePlate":"DB 88 44",
          "countryCode":"dk",
          "vehicleBrand": "toyota",
          "capacityInKg": 1000,
          "driverName": "Carlos-Sainz",
          "imgPath":CarlosSainz,
        },
        {
          "id": "v5",
          "name": "PW 90 741",
          "trailerLicencePlate":"SP 13 78",
          "countryCode":"dk",
          "vehicleBrand": "bmw",
          "capacityInKg": 1000,
          "driverName": "Charles-Leclerc",
          "imgPath":CharlesLeclerc,
        },
        {
          "id": "v6",
          "name": "18-FKS-5",
          "trailerLicencePlate":"OG-70-PD",
          "countryCode":"nl",
          "vehicleBrand": "volvo",
          "capacityInKg": 1000,
          "driverName": "Daniel-Ricciardo",
          "imgPath":DanielRicciardo,
        },
        {
          "id": "v7",
          "name": "1-PEW-002",
          "trailerLicencePlate":"Q-APR-316",
          "countryCode":"be",
          "vehicleBrand": "toyota",
          "capacityInKg": 1000,
          "driverName": "Esteban-Ocon",
          "imgPath":EstebanOcon,
        },
        {
          "id": "v8",
          "name": "2-ABC-002",
          "trailerLicencePlate":"Q-AEW-316",
          "countryCode":"be",
          "vehicleBrand": "volvo",
          "capacityInKg": 1000,
          "driverName": "Fernando-Alonso",
          "imgPath":FernandoAlonso,
        },
        {
          "id": "v9",
          "name": "49-GXD-7",
          "trailerLicencePlate":"OG-79-KL",
          "countryCode":"nl",
          "vehicleBrand": "bmw",
          "capacityInKg": 1000,
          "driverName": "George-Russell",
          "imgPath":GeorgeRussell,
        },
        {
          "id": "v10",
          "name": "64-PWE-7",
          "trailerLicencePlate":"OT-18-PD",
          "countryCode":"nl",
          "vehicleBrand": "bmw",
          "capacityInKg": 1000,
          "driverName": "Kevin-Magnussen",
          "imgPath":KevinMagnussen,
        },
        {
          "id": "v11",
          "name": "BR 89 920",
          "trailerLicencePlate":"NE 45 34",
          "countryCode":"dk",
          "vehicleBrand": "toyota",
          "capacityInKg": 1000,
          "driverName": "Lance-Stroll",
          "imgPath":LanceStroll,
        },
        {
          "id": "v12",
          "name": "43-GXD-5",
          "trailerLicencePlate":"OG-34-PD",
          "countryCode":"nl",
          "vehicleBrand": "bmw",
          "capacityInKg": 1000,
          "driverName": "Lando-Norris",
          "imgPath":LandoNorris,
        },
        {
          "id": "v13",
          "name": "PS 78 920",
          "trailerLicencePlate":"AL 78 44",
          "countryCode":"dk",
          "vehicleBrand": "bmw",
          "capacityInKg": 1000,
          "driverName": "Lewis-Hamilton",
          "imgPath":LewisHamilton,
        },
        {
          "id": "v14",
          "name": "48-GXD-5",
          "trailerLicencePlate":"OT-27-KL",
          "countryCode":"nl",
          "vehicleBrand": "toyota",
          "capacityInKg": 1000,
          "driverName": "Logan-Sargeant",
          "imgPath":LoganSargeant,
        },
        {
          "id": "v15",
          "name": "3-SDS-003",
          "trailerLicencePlate":"Q-AED-798",
          "countryCode":"be",
          "vehicleBrand": "bmw",
          "capacityInKg": 1000,
          "driverName": "Max-Verstappen",
          "imgPath":MaxVerstappen,
        }
      ],
    }, {
      id: 'subcontractors',
      name: 'Boxed Trucks',
      eventCreation: false,
      children: [
        {
          "id": "s1",
          "name": "5-DAA-005",
          "trailerLicencePlate":"W-DSA-123",
          "countryCode":"be",
          "vehicleBrand": "toyota",
          "capacityInKg": 1000,
          "driverName": "Alex-Albon",
          "imgPath":AlexAlbon,
        },
        {
          "id": "s2",
          "name": "1-ADA-001",
          "trailerLicencePlate":"Q-AYP-316",
          "countryCode":"be",
          "vehicleBrand": "volvo",
          "capacityInKg": 1000,
          "driverName": "Carlos-Sainz",
          "imgPath":CarlosSainz,
        },
        {
          "id": "s3",
          "name": "NM 90 920",
          "trailerLicencePlate":"NM 78 44",
          "countryCode":"dk",
          "vehicleBrand": "volvo",
          "capacityInKg": 1000,
          "driverName": "Charles-Leclerc",
          "imgPath":CharlesLeclerc,
        },
        {
          "id": "s4",
          "name": "74-GED-9",
          "trailerLicencePlate":"OG-37-PW",
          "countryCode":"nl",
          "vehicleBrand": "toyota",
          "capacityInKg": 1000,
          "driverName": "Daniel-Ricciardo",
          "imgPath":DanielRicciardo,
        },
        {
          "id": "s5",
          "name": "63-APE-5",
          "trailerLicencePlate":"OG-80-PS",
          "countryCode":"nl",
          "vehicleBrand": "bmw",
          "capacityInKg": 1000,
          "driverName": "Esteban-Ocon",
          "imgPath":EstebanOcon,
        },
        {
          "id": "s6",
          "name": "BE 90 920",
          "trailerLicencePlate":"BT 88 18",
          "countryCode":"dk",
          "vehicleBrand": "toyota",
          "capacityInKg": 1000,
          "driverName": "Fernando-Alonso",
          "imgPath":FernandoAlonso,
        },
        {
          "id": "s7",
          "name": "FR 15 920",
          "trailerLicencePlate":"FR 15 44",
          "countryCode":"dk",
          "vehicleBrand": "volvo",
          "capacityInKg": 1000,
          "driverName": "George-Russell",
          "imgPath":GeorgeRussell,
        },
        {
          "id": "s8",
          "name": "63-AWP-5",
          "trailerLicencePlate":"OG-37-AS",
          "countryCode":"nl",
          "vehicleBrand": "toyota",
          "capacityInKg": 1000,
          "driverName": "Kevin-Magnussen",
          "imgPath":KevinMagnussen,
        },
        {
          "id": "s9",
          "name": "1-DAT-001",
          "trailerLicencePlate":"Q-IYD-316",
          "countryCode":"be",
          "vehicleBrand": "toyota",
          "capacityInKg": 1000,
          "driverName": "Lance-Stroll",
          "imgPath":LanceStroll,
        },
        {
          "id": "s10",
          "name": "79-QAP-5",
          "trailerLicencePlate":"OG-80-QL",
          "countryCode":"nl",
          "vehicleBrand": "volvo",
          "capacityInKg": 1000,
          "driverName": "Lando-Norris",
          "imgPath":LandoNorris,
        },
        {
          "id": "s11",
          "name": "63-PAJ-8",
          "trailerLicencePlate":"OG-56-NT",
          "countryCode":"nl",
          "vehicleBrand": "bmw",
          "capacityInKg": 1000,
          "driverName": "Lewis-Hamilton",
          "imgPath":LewisHamilton,
        },
        {
          "id": "s12",
          "name": "1-ADS-123",
          "trailerLicencePlate":"Q-UYD-316",
          "countryCode":"be",
          "vehicleBrand": "toyota",
          "capacityInKg": 1000,
          "driverName": "Logan-Sargeant",
          "imgPath":LoganSargeant,
        },
        {
          "id": "s13",
          "name": "3-FEA-001",
          "trailerLicencePlate":"Q-PER-316",
          "countryCode":"be",
          "vehicleBrand": "volvo",
          "capacityInKg": 1000,
          "driverName": "Max-Verstappen",
          "imgPath":MaxVerstappen,
        },
        {
          "id": "s14",
          "name": "DS 34 920",
          "trailerLicencePlate":"DW 34 44",
          "countryCode":"dk",
          "vehicleBrand": "toyota",
          "capacityInKg": 1000,
          "driverName": "Nico-Hulkenberg",
          "imgPath":NicoHulkenberg,
        },
        {
          "id": "s15",
          "name": "BT 32 920",
          "trailerLicencePlate":"QW 34 44",
          "countryCode":"dk",
          "vehicleBrand": "toyota",
          "capacityInKg": 1000,
          "driverName": "Pierre-Gasly",
          "imgPath":PierreGasly,
        }
      ],
    },
    {
      id: 'trailors',
      name: 'Flatbed Trucks',
      eventCreation: false,
      children: [
        {
          "id": "t1",
          "name": "63-LEK-5",
          "trailerLicencePlate":"OT-34-IY",
          "countryCode":"nl",
          "vehicleBrand": "bmw",
          "capacityInKg": 1000,
          "driverName": "Nico-Hulkenberg",
          "imgPath":NicoHulkenberg,
        },
        {
          "id": "t2",
          "name": "4-APR-001",
          "trailerLicencePlate":"Q-DEP-316",
          "countryCode":"be",
          "vehicleBrand": "volvo",
          "capacityInKg": 1000,
          "driverName": "Pierre-Gasly",
          "imgPath":PierreGasly,
        },
        {
          "id": "t3",
          "name": "1-APE-498",
          "trailerLicencePlate":"Q-AAP-316",
          "countryCode":"be",
          "vehicleBrand": "toyota",
          "capacityInKg": 1000,
          "driverName": "Sergio-Perez",
          "imgPath":SergioPerez,
        },
        {
          "id": "t4",
          "name": "NY 89 987",
          "trailerLicencePlate":"GE 45 23",
          "countryCode":"dk",
          "vehicleBrand": "volvo",
          "capacityInKg": 1000,
          "driverName": "Valtteri-Bottas",
          "imgPath":ValtteriBottas,
        },
        {
          "id": "t5",
          "name": "DE 90 125",
          "trailerLicencePlate":"SD 23 54",
          "countryCode":"dk",
          "vehicleBrand": "toyota",
          "capacityInKg": 1000,
          "driverName": "Alex-Albon",
          "imgPath":AlexAlbon,
        },
        {
          "id": "t6",
          "name": "23-WDA-5",
          "trailerLicencePlate":"OG-12-WL",
          "countryCode":"nl",
          "vehicleBrand": "bmw",
          "capacityInKg": 1000,
          "driverName": "Carlos-Sainz",
          "imgPath":CarlosSainz,
        },
        {
          "id": "t7",
          "name": "40-WNT-5",
          "trailerLicencePlate":"OG-89-FG",
          "countryCode":"nl",
          "vehicleBrand": "volvo",
          "capacityInKg": 1000,
          "driverName": "Charles-Leclerc",
          "imgPath":CharlesLeclerc,
        },
        {
          "id": "t8",
          "name": "1-LPA-159",
          "trailerLicencePlate":"Q-AYP-749",
          "countryCode":"be",
          "vehicleBrand": "toyota",
          "capacityInKg": 1000,
          "driverName": "Daniel-Ricciardo",
          "imgPath":DanielRicciardo,
        },
        {
          "id": "t9",
          "name": "54-GXD-5",
          "trailerLicencePlate":"OT-80-FE",
          "countryCode":"nl",
          "vehicleBrand": "toyota",
          "capacityInKg": 1000,
          "driverName": "Esteban-Ocon",
          "imgPath":EstebanOcon,
        },
        {
          "id": "t10",
          "name": "1-APR-741",
          "trailerLicencePlate":"Q-AHR-784",
          "countryCode":"be",
          "vehicleBrand": "volvo",
          "capacityInKg": 1000,
          "driverName": "Fernando-Alonso",
          "imgPath":FernandoAlonso,
        },
        {
          "id": "t11",
          "name": "63-BYI-5",
          "trailerLicencePlate":"OT-80-ER",
          "countryCode":"nl",
          "vehicleBrand": "bmw",
          "capacityInKg": 1000,
          "driverName": "George-Russell",
          "imgPath":GeorgeRussell,
        },
        {
          "id": "t12",
          "name": "BR 90 346",
          "trailerLicencePlate":"AE 34 22",
          "countryCode":"dk",
          "vehicleBrand": "volvo",
          "capacityInKg": 1000,
          "driverName": "Kevin-Magnussen",
          "imgPath":KevinMagnussen,
        },
        {
          "id": "t13",
          "name": "HY 67 236",
          "trailerLicencePlate":"AD 88 98",
          "countryCode":"dk",
          "vehicleBrand": "volvo",
          "capacityInKg": 1000,
          "driverName": "Lance-Stroll",
          "imgPath":LanceStroll,
        },
        {
          "id": "t14",
          "name": "63-BEW-5",
          "trailerLicencePlate":"OG-34-AD",
          "countryCode":"nl",
          "vehicleBrand": "toyota",
          "capacityInKg": 1000,
          "driverName": "Lando-Norris",
          "imgPath":LandoNorris,
        },
        {
          "id": "t15",
          "name": "7-ACN-784",
          "trailerLicencePlate":"Q-WDH-357",
          "countryCode":"be",
          "vehicleBrand": "volvo",
          "capacityInKg": 1000,
          "driverName": "Lewis-Hamilton",
          "imgPath":LewisHamilton,
        }
      ],
    },
  ]
  
  export const msTrailerResourceData = [
    {
        "id": "vehicle",
        "name": "Boxed Trailers",
        "eventCreation": false,
        "children": [
            {
                "id": "v8",
                "name": "2-ABC-002",
                "trailerLicencePlate": "Q-AEW-316",
                "countryCode": "be",
                "vehicleBrand": "volvo",
                "capacityInKg": 1000,
                "driverName": "Fernando-Alonso",
                "imgPath":FernandoAlonso,
                "depth": 1,
                "isParent": false
            },
            {
              "id": "v1",
              "name": "63-GXD-5",
              "trailerLicencePlate": "OG-80-KL",
              "countryCode": "nl",
              "vehicleBrand": "bmw",
              "capacityInKg": 1000,
              "eventCreation": false,
              "driverName": "Sergio-Perez",
              "imgPath":SergioPerez,
              "depth": 1,
              "isParent": false
          },
            {
                "id": "v15",
                "name": "3-SDS-003",
                "trailerLicencePlate": "Q-AED-798",
                "countryCode": "be",
                "vehicleBrand": "bmw",
                "capacityInKg": 1000,
                "driverName": "Max-Verstappen",
                "imgPath":MaxVerstappen,
                "depth": 1,
                "isParent": false
            },
            {
                "id": "v11",
                "name": "BR 89 920",
                "trailerLicencePlate": "NE 45 34",
                "countryCode": "dk",
                "vehicleBrand": "toyota",
                "capacityInKg": 1000,
                "driverName": "Lance-Stroll",
                "imgPath":LanceStroll,
                "depth": 1,
                "isParent": false
            },
            {
                "id": "v13",
                "name": "PS 78 920",
                "trailerLicencePlate": "AL 78 44",
                "countryCode": "dk",
                "vehicleBrand": "bmw",
                "capacityInKg": 1000,
                "driverName": "Lewis-Hamilton",
                "imgPath":LewisHamilton,
                "depth": 1,
                "isParent": false
            },
            {
                "id": "v9",
                "name": "49-GXD-7",
                "trailerLicencePlate": "OG-79-KL",
                "countryCode": "nl",
                "vehicleBrand": "bmw",
                "capacityInKg": 1000,
                "driverName": "George-Russell",
                "imgPath":GeorgeRussell,
                "depth": 1,
                "isParent": false
            },
            {
                "id": "v7",
                "name": "1-PEW-002",
                "trailerLicencePlate": "Q-APR-316",
                "countryCode": "be",
                "vehicleBrand": "toyota",
                "capacityInKg": 1000,
                "driverName": "Esteban-Ocon",
                "imgPath":EstebanOcon,
                "depth": 1,
                "isParent": false
            },            
            {
                "id": "v6",
                "name": "18-FKS-5",
                "trailerLicencePlate": "OG-70-PD",
                "countryCode": "nl",
                "vehicleBrand": "volvo",
                "capacityInKg": 1000,
                "driverName": "Daniel-Ricciardo",
                "imgPath":DanielRicciardo,
                "depth": 1,
                "isParent": false
            },
            {
                "id": "v3",
                "name": "1-ABC-001",
                "trailerLicencePlate": "Q-AYP-316",
                "countryCode": "be",
                "vehicleBrand": "toyota",
                "capacityInKg": 1000,
                "driverName": "Alex-Albon",
                "imgPath":AlexAlbon,
                "depth": 1,
                "isParent": false
            },
            {
                "id": "v4",
                "name": "BG 90 920",
                "trailerLicencePlate": "DB 88 44",
                "countryCode": "dk",
                "vehicleBrand": "toyota",
                "capacityInKg": 1000,
                "driverName": "Carlos-Sainz",
                "imgPath":CarlosSainz,
                "depth": 1,
                "isParent": false
            },
            {
                "id": "v10",
                "name": "64-PWE-7",
                "trailerLicencePlate": "OT-18-PD",
                "countryCode": "nl",
                "vehicleBrand": "bmw",
                "capacityInKg": 1000,
                "driverName": "Kevin-Magnussen",
                "imgPath":KevinMagnussen,
                "depth": 1,
                "isParent": false
            },
            {
                "id": "v12",
                "name": "43-GXD-5",
                "trailerLicencePlate": "OG-34-PD",
                "countryCode": "nl",
                "vehicleBrand": "bmw",
                "capacityInKg": 1000,
                "driverName": "Lando-Norris",
                "imgPath":LandoNorris,
                "depth": 1,
                "isParent": false
            },
            {
                "id": "v5",
                "name": "PW 90 741",
                "trailerLicencePlate": "SP 13 78",
                "countryCode": "dk",
                "vehicleBrand": "bmw",
                "capacityInKg": 1000,
                "driverName": "Charles-Leclerc",
                "imgPath":CharlesLeclerc,
                "depth": 1,
                "isParent": false
            },
            {
                "id": "v14",
                "name": "48-GXD-5",
                "trailerLicencePlate": "OT-27-KL",
                "countryCode": "nl",
                "vehicleBrand": "toyota",
                "capacityInKg": 1000,
                "driverName": "Logan-Sargeant",
                "imgPath":LoganSargeant,
                "depth": 1,
                "isParent": false
            },
            {
                "id": "v2",
                "name": "89-DKF-5",
                "trailerLicencePlate": "OT-88-KD",
                "countryCode": "nl",
                "vehicleBrand": "volvo",
                "capacityInKg": 800,
                "driverName": "Valtteri-Bottas",
                "imgPath":ValtteriBottas,
                "depth": 1,
                "isParent": false
            }
        ],
        "depth": 0,
        "isParent": true
    },
    {
        "id": "subcontractors",
        "name": "Tank Trailers",
        "eventCreation": false,
        "children": [
            {
                "id": "s1",
                "name": "5-DAA-005",
                "trailerLicencePlate": "W-DSA-123",
                "countryCode": "be",
                "vehicleBrand": "toyota",
                "capacityInKg": 1000,
                "driverName": "Alex-Albon",
                "imgPath":AlexAlbon,
                "depth": 1,
                "isParent": false
            },
            {
                "id": "s11",
                "name": "63-PAJ-8",
                "trailerLicencePlate": "OG-56-NT",
                "countryCode": "nl",
                "vehicleBrand": "bmw",
                "capacityInKg": 1000,
                "driverName": "Lewis-Hamilton",
                "imgPath":LewisHamilton,
                "depth": 1,
                "isParent": false
            },
            {
                "id": "s8",
                "name": "63-AWP-5",
                "trailerLicencePlate": "OG-37-AS",
                "countryCode": "nl",
                "vehicleBrand": "toyota",
                "capacityInKg": 1000,
                "driverName": "Kevin-Magnussen",
                "imgPath":KevinMagnussen,
                "depth": 1,
                "isParent": false
            },
            {
                "id": "s13",
                "name": "3-FEA-001",
                "trailerLicencePlate": "Q-PER-316",
                "countryCode": "be",
                "vehicleBrand": "volvo",
                "capacityInKg": 1000,
                "driverName": "Max-Verstappen",
                "imgPath":MaxVerstappen,
                "depth": 1,
                "isParent": false
            },
            {
                "id": "s3",
                "name": "NM 90 920",
                "trailerLicencePlate": "NM 78 44",
                "countryCode": "dk",
                "vehicleBrand": "volvo",
                "capacityInKg": 1000,
                "driverName": "Charles-Leclerc",
                "imgPath":CharlesLeclerc,
                "depth": 1,
                "isParent": false
            },
            {
                "id": "s9",
                "name": "1-DAT-001",
                "trailerLicencePlate": "Q-IYD-316",
                "countryCode": "be",
                "vehicleBrand": "toyota",
                "capacityInKg": 1000,
                "driverName": "Lance-Stroll",
                "imgPath":LanceStroll,
                "depth": 1,
                "isParent": false
            },
            {
                "id": "s5",
                "name": "63-APE-5",
                "trailerLicencePlate": "OG-80-PS",
                "countryCode": "nl",
                "vehicleBrand": "bmw",
                "capacityInKg": 1000,
                "driverName": "Esteban-Ocon",
                "imgPath":EstebanOcon,
                "depth": 1,
                "isParent": false
            },
            {
                "id": "s6",
                "name": "BE 90 920",
                "trailerLicencePlate": "BT 88 18",
                "countryCode": "dk",
                "vehicleBrand": "toyota",
                "capacityInKg": 1000,
                "driverName": "Fernando-Alonso",
                "imgPath":FernandoAlonso,
                "depth": 1,
                "isParent": false
            },
            {
                "id": "s15",
                "name": "BT 32 920",
                "trailerLicencePlate": "QW 34 44",
                "countryCode": "dk",
                "vehicleBrand": "toyota",
                "capacityInKg": 1000,
                "driverName": "Pierre-Gasly",
                "imgPath":PierreGasly,
                "depth": 1,
                "isParent": false
            },
            {
                "id": "s7",
                "name": "FR 15 920",
                "trailerLicencePlate": "FR 15 44",
                "countryCode": "dk",
                "vehicleBrand": "volvo",
                "capacityInKg": 1000,
                "driverName": "George-Russell",
                "imgPath":GeorgeRussell,
                "depth": 1,
                "isParent": false
            },
            {
                "id": "s10",
                "name": "79-QAP-5",
                "trailerLicencePlate": "OG-80-QL",
                "countryCode": "nl",
                "vehicleBrand": "volvo",
                "capacityInKg": 1000,
                "driverName": "Lando-Norris",
                "imgPath":LandoNorris,
                "depth": 1,
                "isParent": false
            },
            {
                "id": "s4",
                "name": "74-GED-9",
                "trailerLicencePlate": "OG-37-PW",
                "countryCode": "nl",
                "vehicleBrand": "toyota",
                "capacityInKg": 1000,
                "driverName": "Daniel-Ricciardo",
                "imgPath":DanielRicciardo,
                "depth": 1,
                "isParent": false
            },
            {
                "id": "s12",
                "name": "1-ADS-123",
                "trailerLicencePlate": "Q-UYD-316",
                "countryCode": "be",
                "vehicleBrand": "toyota",
                "capacityInKg": 1000,
                "driverName": "Logan-Sargeant",
                "imgPath":LoganSargeant,
                "depth": 1,
                "isParent": false
            },
            {
                "id": "s14",
                "name": "DS 34 920",
                "trailerLicencePlate": "DW 34 44",
                "countryCode": "dk",
                "vehicleBrand": "toyota",
                "capacityInKg": 1000,
                "driverName": "Nico-Hulkenberg",
                "imgPath":NicoHulkenberg,
                "depth": 1,
                "isParent": false
            },
            {
                "id": "s2",
                "name": "1-ADA-001",
                "trailerLicencePlate": "Q-AYP-316",
                "countryCode": "be",
                "vehicleBrand": "volvo",
                "capacityInKg": 1000,
                "driverName": "Carlos-Sainz",
                "imgPath":CarlosSainz,
                "depth": 1,
                "isParent": false
            }
        ],
        "depth": 0,
        "isParent": true
    },
    {
        "id": "trailors",
        "name": "Chassis",
        "eventCreation": false,
        "children": [
            {
                "id": "t5",
                "name": "DE 90 125",
                "trailerLicencePlate": "SD 23 54",
                "countryCode": "dk",
                "vehicleBrand": "toyota",
                "capacityInKg": 1000,
                "driverName": "Alex-Albon",
                "imgPath":AlexAlbon,
                "depth": 1,
                "isParent": false
            },
            {
                "id": "t12",
                "name": "BR 90 346",
                "trailerLicencePlate": "AE 34 22",
                "countryCode": "dk",
                "vehicleBrand": "volvo",
                "capacityInKg": 1000,
                "driverName": "Kevin-Magnussen",
                "imgPath":KevinMagnussen,
                "depth": 1,
                "isParent": false
            },
            {
                "id": "t1",
                "name": "63-LEK-5",
                "trailerLicencePlate": "OT-34-IY",
                "countryCode": "nl",
                "vehicleBrand": "bmw",
                "capacityInKg": 1000,
                "driverName": "Nico-Hulkenberg",
                "imgPath":NicoHulkenberg,
                "depth": 1,
                "isParent": false
            },
            {
                "id": "t7",
                "name": "40-WNT-5",
                "trailerLicencePlate": "OG-89-FG",
                "countryCode": "nl",
                "vehicleBrand": "volvo",
                "capacityInKg": 1000,
                "driverName": "Charles-Leclerc",
                "imgPath":CharlesLeclerc,
                "depth": 1,
                "isParent": false
            },
            {
                "id": "t3",
                "name": "1-APE-498",
                "trailerLicencePlate": "Q-AAP-316",
                "countryCode": "be",
                "vehicleBrand": "toyota",
                "capacityInKg": 1000,
                "driverName": "Sergio-Perez",
                "imgPath":SergioPerez,
                "depth": 1,
                "isParent": false
            },
            {
                "id": "t15",
                "name": "7-ACN-784",
                "trailerLicencePlate": "Q-WDH-357",
                "countryCode": "be",
                "vehicleBrand": "volvo",
                "capacityInKg": 1000,
                "driverName": "Alex-Albon",
                "imgPath":AlexAlbon,
                "depth": 1,
                "isParent": false
            },
            {
                "id": "t8",
                "name": "1-LPA-159",
                "trailerLicencePlate": "Q-AYP-749",
                "countryCode": "be",
                "vehicleBrand": "toyota",
                "capacityInKg": 1000,
                "driverName": "Daniel-Ricciardo",
                "imgPath":DanielRicciardo,
                "depth": 1,
                "isParent": false
            },
            {
                "id": "t2",
                "name": "4-APR-001",
                "trailerLicencePlate": "Q-DEP-316",
                "countryCode": "be",
                "vehicleBrand": "volvo",
                "capacityInKg": 1000,
                "driverName": "Pierre-Gasly",
                "imgPath":PierreGasly,
                "depth": 1,
                "isParent": false
            },
            {
                "id": "t6",
                "name": "23-WDA-5",
                "trailerLicencePlate": "OG-12-WL",
                "countryCode": "nl",
                "vehicleBrand": "bmw",
                "capacityInKg": 1000,
                "driverName": "Carlos-Sainz",
                "imgPath":CarlosSainz,
                "depth": 1,
                "isParent": false
            },
            {
                "id": "t14",
                "name": "63-BEW-5",
                "trailerLicencePlate": "OG-34-AD",
                "countryCode": "nl",
                "vehicleBrand": "toyota",
                "capacityInKg": 1000,
                "driverName": "Lando-Norris",
                "imgPath":LandoNorris,
                "depth": 1,
                "isParent": false
            },
            {
                "id": "t11",
                "name": "63-BYI-5",
                "trailerLicencePlate": "OT-80-ER",
                "countryCode": "nl",
                "vehicleBrand": "bmw",
                "capacityInKg": 1000,
                "driverName": "George-Russell",
                "imgPath":GeorgeRussell,
                "depth": 1,
                "isParent": false
            },
            {
                "id": "t4",
                "name": "NY 89 987",
                "trailerLicencePlate": "GE 45 23",
                "countryCode": "dk",
                "vehicleBrand": "volvo",
                "capacityInKg": 1000,
                "driverName": "Valtteri-Bottas",
                "imgPath":ValtteriBottas,
                "depth": 1,
                "isParent": false
            },
            {
                "id": "t13",
                "name": "HY 67 236",
                "trailerLicencePlate": "AD 88 98",
                "countryCode": "dk",
                "vehicleBrand": "volvo",
                "capacityInKg": 1000,
                "driverName": "Charles-Leclerc",
                "imgPath":CharlesLeclerc,
                "depth": 1,
                "isParent": false
            },
            {
                "id": "t10",
                "name": "1-APR-741",
                "trailerLicencePlate": "Q-AHR-784",
                "countryCode": "be",
                "vehicleBrand": "volvo",
                "capacityInKg": 1000,
                "driverName": "Fernando-Alonso",
                "imgPath":FernandoAlonso,
                "depth": 1,
                "isParent": false
            },
            {
                "id": "t9",
                "name": "54-GXD-5",
                "trailerLicencePlate": "OT-80-FE",
                "countryCode": "nl",
                "vehicleBrand": "toyota",
                "capacityInKg": 1000,
                "driverName": "Esteban-Ocon",
                "imgPath":EstebanOcon,
                "depth": 1,
                "isParent": false
            }
        ],
        "depth": 0,
        "isParent": true
    }
]
export const msDriverResourceData = [
  {
      "id": "vehicle",
      "name": "Combinations",
      "eventCreation": false,
      "children": [
          {
              "id": "v13",
              "name": "PS 78 920",
              "trailerLicencePlate": "AL 78 44",
              "countryCode": "dk",
              "vehicleBrand": "bmw",
              "capacityInKg": 1000,
              "driverName": "Lewis-Hamilton",
              "imgPath":LewisHamilton,
              "depth": 1,
              "isParent": false
          },
          {
              "id": "v8",
              "name": "2-ABC-002",
              "trailerLicencePlate": "Q-AEW-316",
              "countryCode": "be",
              "vehicleBrand": "volvo",
              "capacityInKg": 1000,
              "driverName": "Fernando-Alonso",
              "imgPath":FernandoAlonso,
              "depth": 1,
              "isParent": false
          },
          {
              "id": "v10",
              "name": "64-PWE-7",
              "trailerLicencePlate": "OT-18-PD",
              "countryCode": "nl",
              "vehicleBrand": "bmw",
              "capacityInKg": 1000,
              "driverName": "Kevin-Magnussen",
              "imgPath":KevinMagnussen,
              "depth": 1,
              "isParent": false
          },
          {
              "id": "v3",
              "name": "1-ABC-001",
              "trailerLicencePlate": "Q-AYP-316",
              "countryCode": "be",
              "vehicleBrand": "toyota",
              "capacityInKg": 1000,
              "driverName": "Alex-Albon",
              "imgPath":AlexAlbon,
              "depth": 1,
              "isParent": false
          },
          {
              "id": "v9",
              "name": "49-GXD-7",
              "trailerLicencePlate": "OG-79-KL",
              "countryCode": "nl",
              "vehicleBrand": "bmw",
              "capacityInKg": 1000,
              "driverName": "George-Russell",
              "imgPath":GeorgeRussell,
              "depth": 1,
              "isParent": false
          },
          {
              "id": "v11",
              "name": "BR 89 920",
              "trailerLicencePlate": "NE 45 34",
              "countryCode": "dk",
              "vehicleBrand": "toyota",
              "capacityInKg": 1000,
              "driverName": "Lance-Stroll",
              "imgPath":LanceStroll,
              "depth": 1,
              "isParent": false
          },
          {
              "id": "v4",
              "name": "BG 90 920",
              "trailerLicencePlate": "DB 88 44",
              "countryCode": "dk",
              "vehicleBrand": "toyota",
              "capacityInKg": 1000,
              "driverName": "Carlos-Sainz",
              "imgPath":CarlosSainz,
              "depth": 1,
              "isParent": false
          },
          {
              "id": "v5",
              "name": "PW 90 741",
              "trailerLicencePlate": "SP 13 78",
              "countryCode": "dk",
              "vehicleBrand": "bmw",
              "capacityInKg": 1000,
              "driverName": "Charles-Leclerc",
              "imgPath":CharlesLeclerc,
              "depth": 1,
              "isParent": false
          },
          {
              "id": "v2",
              "name": "89-DKF-5",
              "trailerLicencePlate": "OT-88-KD",
              "countryCode": "nl",
              "vehicleBrand": "volvo",
              "capacityInKg": 800,
              "driverName": "Valtteri-Bottas",
              "imgPath":ValtteriBottas,
              "depth": 1,
              "isParent": false
          },
          {
              "id": "v14",
              "name": "48-GXD-5",
              "trailerLicencePlate": "OT-27-KL",
              "countryCode": "nl",
              "vehicleBrand": "toyota",
              "capacityInKg": 1000,
              "driverName": "Logan-Sargeant",
              "imgPath":LoganSargeant,
              "depth": 1,
              "isParent": false
          },
          {
              "id": "v7",
              "name": "1-PEW-002",
              "trailerLicencePlate": "Q-APR-316",
              "countryCode": "be",
              "vehicleBrand": "toyota",
              "capacityInKg": 1000,
              "driverName": "Esteban-Ocon",
              "imgPath":EstebanOcon,
              "depth": 1,
              "isParent": false
          },
          {
              "id": "v15",
              "name": "3-SDS-003",
              "trailerLicencePlate": "Q-AED-798",
              "countryCode": "be",
              "vehicleBrand": "bmw",
              "capacityInKg": 1000,
              "driverName": "Max-Verstappen",
              "imgPath":MaxVerstappen,
              "depth": 1,
              "isParent": false
          },
          {
              "id": "v12",
              "name": "43-GXD-5",
              "trailerLicencePlate": "OG-34-PD",
              "countryCode": "nl",
              "vehicleBrand": "bmw",
              "capacityInKg": 1000,
              "driverName": "Lando-Norris",
              "imgPath":LandoNorris,
              "depth": 1,
              "isParent": false
          },
          {
              "id": "v6",
              "name": "18-FKS-5",
              "trailerLicencePlate": "OG-70-PD",
              "countryCode": "nl",
              "vehicleBrand": "volvo",
              "capacityInKg": 1000,
              "driverName": "Daniel-Ricciardo",
              "imgPath":DanielRicciardo,
              "depth": 1,
              "isParent": false
          },
          {
              "id": "v1",
              "name": "63-GXD-5",
              "trailerLicencePlate": "OG-80-KL",
              "countryCode": "nl",
              "vehicleBrand": "bmw",
              "capacityInKg": 1000,
              "eventCreation": false,
              "driverName": "Sergio-Perez",
              "imgPath":SergioPerez,
              "depth": 1,
              "isParent": false
          }
      ],
      "depth": 0,
      "isParent": true
  },
  {
      "id": "subcontractors",
      "name": "Internationals",
      "eventCreation": false,
      "children": [
          {
              "id": "s6",
              "name": "BE 90 920",
              "trailerLicencePlate": "BT 88 18",
              "countryCode": "dk",
              "vehicleBrand": "toyota",
              "capacityInKg": 1000,
              "driverName": "Fernando-Alonso",
              "imgPath":FernandoAlonso,
              "depth": 1,
              "isParent": false
          },
          {
              "id": "s3",
              "name": "NM 90 920",
              "trailerLicencePlate": "NM 78 44",
              "countryCode": "dk",
              "vehicleBrand": "volvo",
              "capacityInKg": 1000,
              "driverName": "Charles-Leclerc",
              "imgPath":CharlesLeclerc,
              "depth": 1,
              "isParent": false
          },
          {
              "id": "s12",
              "name": "1-ADS-123",
              "trailerLicencePlate": "Q-UYD-316",
              "countryCode": "be",
              "vehicleBrand": "toyota",
              "capacityInKg": 1000,
              "driverName": "Logan-Sargeant",
              "imgPath":LoganSargeant,
              "depth": 1,
              "isParent": false
          },
          {
              "id": "s9",
              "name": "1-DAT-001",
              "trailerLicencePlate": "Q-IYD-316",
              "countryCode": "be",
              "vehicleBrand": "toyota",
              "capacityInKg": 1000,
              "driverName": "Lance-Stroll",
              "imgPath":LanceStroll,
              "depth": 1,
              "isParent": false
          },
          {
              "id": "s14",
              "name": "DS 34 920",
              "trailerLicencePlate": "DW 34 44",
              "countryCode": "dk",
              "vehicleBrand": "toyota",
              "capacityInKg": 1000,
              "driverName": "Nico-Hulkenberg",
              "imgPath":NicoHulkenberg,
              "depth": 1,
              "isParent": false
          },
          {
              "id": "s13",
              "name": "3-FEA-001",
              "trailerLicencePlate": "Q-PER-316",
              "countryCode": "be",
              "vehicleBrand": "volvo",
              "capacityInKg": 1000,
              "driverName": "Max-Verstappen",
              "imgPath":MaxVerstappen,
              "depth": 1,
              "isParent": false
          },
          {
              "id": "s15",
              "name": "BT 32 920",
              "trailerLicencePlate": "QW 34 44",
              "countryCode": "dk",
              "vehicleBrand": "toyota",
              "capacityInKg": 1000,
              "driverName": "Pierre-Gasly",
              "imgPath":PierreGasly,
              "depth": 1,
              "isParent": false
          },
          {
              "id": "s11",
              "name": "63-PAJ-8",
              "trailerLicencePlate": "OG-56-NT",
              "countryCode": "nl",
              "vehicleBrand": "bmw",
              "capacityInKg": 1000,
              "driverName": "Lewis-Hamilton",
              "imgPath":LewisHamilton,
              "depth": 1,
              "isParent": false
          },
          {
              "id": "s2",
              "name": "1-ADA-001",
              "trailerLicencePlate": "Q-AYP-316",
              "countryCode": "be",
              "vehicleBrand": "volvo",
              "capacityInKg": 1000,
              "driverName": "Carlos-Sainz",
              "imgPath":CarlosSainz,
              "depth": 1,
              "isParent": false
          },
          {
              "id": "s8",
              "name": "63-AWP-5",
              "trailerLicencePlate": "OG-37-AS",
              "countryCode": "nl",
              "vehicleBrand": "toyota",
              "capacityInKg": 1000,
              "driverName": "Kevin-Magnussen",
              "imgPath":KevinMagnussen,
              "depth": 1,
              "isParent": false
          },
          {
              "id": "s1",
              "name": "5-DAA-005",
              "trailerLicencePlate": "W-DSA-123",
              "countryCode": "be",
              "vehicleBrand": "toyota",
              "capacityInKg": 1000,
              "driverName": "Alex-Albon",
              "imgPath":AlexAlbon,
              "depth": 1,
              "isParent": false
          },
          {
              "id": "s7",
              "name": "FR 15 920",
              "trailerLicencePlate": "FR 15 44",
              "countryCode": "dk",
              "vehicleBrand": "volvo",
              "capacityInKg": 1000,
              "driverName": "George-Russell",
              "imgPath":GeorgeRussell,
              "depth": 1,
              "isParent": false
          },
          {
              "id": "s4",
              "name": "74-GED-9",
              "trailerLicencePlate": "OG-37-PW",
              "countryCode": "nl",
              "vehicleBrand": "toyota",
              "capacityInKg": 1000,
              "driverName": "Daniel-Ricciardo",
              "imgPath":DanielRicciardo,
              "depth": 1,
              "isParent": false
          },
          {
              "id": "s10",
              "name": "79-QAP-5",
              "trailerLicencePlate": "OG-80-QL",
              "countryCode": "nl",
              "vehicleBrand": "volvo",
              "capacityInKg": 1000,
              "driverName": "Lando-Norris",
              "imgPath":LandoNorris,
              "depth": 1,
              "isParent": false
          },
          {
              "id": "s5",
              "name": "63-APE-5",
              "trailerLicencePlate": "OG-80-PS",
              "countryCode": "nl",
              "vehicleBrand": "bmw",
              "capacityInKg": 1000,
              "driverName": "Esteban-Ocon",
              "imgPath":EstebanOcon,
              "depth": 1,
              "isParent": false
          }
      ],
      "depth": 0,
      "isParent": true
  },
  {
      "id": "trailors",
      "name": "National",
      "eventCreation": false,
      "children": [
          {
              "id": "t10",
              "name": "1-APR-741",
              "trailerLicencePlate": "Q-AHR-784",
              "countryCode": "be",
              "vehicleBrand": "volvo",
              "capacityInKg": 1000,
              "driverName": "Fernando-Alonso",
              "imgPath":FernandoAlonso,
              "depth": 1,
              "isParent": false
          },
          {
              "id": "t14",
              "name": "63-BEW-5",
              "trailerLicencePlate": "OG-34-AD",
              "countryCode": "nl",
              "vehicleBrand": "toyota",
              "capacityInKg": 1000,
              "driverName": "Lando-Norris",
              "imgPath":LandoNorris,
              "depth": 1,
              "isParent": false
          },
          {
              "id": "t9",
              "name": "54-GXD-5",
              "trailerLicencePlate": "OT-80-FE",
              "countryCode": "nl",
              "vehicleBrand": "toyota",
              "capacityInKg": 1000,
              "driverName": "Esteban-Ocon",
              "imgPath":EstebanOcon,
              "depth": 1,
              "isParent": false
          },
          {
              "id": "t4",
              "name": "NY 89 987",
              "trailerLicencePlate": "GE 45 23",
              "countryCode": "dk",
              "vehicleBrand": "volvo",
              "capacityInKg": 1000,
              "driverName": "Valtteri-Bottas",
              "imgPath":ValtteriBottas,
              "depth": 1,
              "isParent": false
          },
          {
              "id": "t7",
              "name": "40-WNT-5",
              "trailerLicencePlate": "OG-89-FG",
              "countryCode": "nl",
              "vehicleBrand": "volvo",
              "capacityInKg": 1000,
              "driverName": "Charles-Leclerc",
              "imgPath":CharlesLeclerc,
              "depth": 1,
              "isParent": false
          },
          {
              "id": "t13",
              "name": "HY 67 236",
              "trailerLicencePlate": "AD 88 98",
              "countryCode": "dk",
              "vehicleBrand": "volvo",
              "capacityInKg": 1000,
              "driverName": "Charles-Leclerc",
              "imgPath":CharlesLeclerc,
              "depth": 1,
              "isParent": false
          },
          {
              "id": "t11",
              "name": "63-BYI-5",
              "trailerLicencePlate": "OT-80-ER",
              "countryCode": "nl",
              "vehicleBrand": "bmw",
              "capacityInKg": 1000,
              "driverName": "George-Russell",
              "imgPath":GeorgeRussell,
              "depth": 1,
              "isParent": false
          },
          {
              "id": "t15",
              "name": "7-ACN-784",
              "trailerLicencePlate": "Q-WDH-357",
              "countryCode": "be",
              "vehicleBrand": "volvo",
              "capacityInKg": 1000,
              "driverName": "Alex-Albon",
              "imgPath":AlexAlbon,
              "depth": 1,
              "isParent": false
          },
          {
              "id": "t3",
              "name": "1-APE-498",
              "trailerLicencePlate": "Q-AAP-316",
              "countryCode": "be",
              "vehicleBrand": "toyota",
              "capacityInKg": 1000,
              "driverName": "Sergio-Perez",
              "imgPath":SergioPerez,
              "depth": 1,
              "isParent": false
          },
          {
              "id": "t5",
              "name": "DE 90 125",
              "trailerLicencePlate": "SD 23 54",
              "countryCode": "dk",
              "vehicleBrand": "toyota",
              "capacityInKg": 1000,
              "driverName": "Alex-Albon",
              "imgPath":AlexAlbon,
              "depth": 1,
              "isParent": false
          },
          {
              "id": "t2",
              "name": "4-APR-001",
              "trailerLicencePlate": "Q-DEP-316",
              "countryCode": "be",
              "vehicleBrand": "volvo",
              "capacityInKg": 1000,
              "driverName": "Pierre-Gasly",
              "imgPath":PierreGasly,
              "depth": 1,
              "isParent": false
          },
          {
              "id": "t8",
              "name": "1-LPA-159",
              "trailerLicencePlate": "Q-AYP-749",
              "countryCode": "be",
              "vehicleBrand": "toyota",
              "capacityInKg": 1000,
              "driverName": "Daniel-Ricciardo",
              "imgPath":DanielRicciardo,
              "depth": 1,
              "isParent": false
          },
          {
              "id": "t12",
              "name": "BR 90 346",
              "trailerLicencePlate": "AE 34 22",
              "countryCode": "dk",
              "vehicleBrand": "volvo",
              "capacityInKg": 1000,
              "driverName": "Kevin-Magnussen",
              "imgPath":KevinMagnussen,
              "depth": 1,
              "isParent": false
          },
          {
              "id": "t6",
              "name": "23-WDA-5",
              "trailerLicencePlate": "OG-12-WL",
              "countryCode": "nl",
              "vehicleBrand": "bmw",
              "capacityInKg": 1000,
              "driverName": "Carlos-Sainz",
              "imgPath":CarlosSainz,
              "depth": 1,
              "isParent": false
          },
          {
              "id": "t1",
              "name": "63-LEK-5",
              "trailerLicencePlate": "OT-34-IY",
              "countryCode": "nl",
              "vehicleBrand": "bmw",
              "capacityInKg": 1000,
              "driverName": "Nico-Hulkenberg",
              "imgPath":NicoHulkenberg,
              "depth": 1,
              "isParent": false
          }
      ],
      "depth": 0,
      "isParent": true
  }
]
